import { Box, Dialog, Menu, Accordion, Collapse, AccordionSummary, AccordionDetails, MenuItem, CircularProgress, Chip, Pagination, AppBar, ListItemText, Toolbar, ListItemIcon, TableContainer, Checkbox, Modal, DialogActions, DialogContent, Table, TableHead, TableBody, TableRow, TableCell, useTheme, Tooltip, FormControl, Card, Autocomplete, Grid, Typography, Stack, Divider, TextField, CardHeader, CardContent, IconButton, FormControlLabel, Button, Avatar, alpha } from "@mui/material";
import React, { useEffect, useState, useMemo } from "react";

import Close from '@mui/icons-material/Close';
import Header from "../../../Layout/Header";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from "dayjs";

import 'dayjs/plugin/customParseFormat';
import EditIcon from '@mui/icons-material/Edit';


import { tokens } from "../../../theme/theme";
import CallAlertBar from "../../../Layout/Alertbar";

import QrCode2RoundedIcon from '@mui/icons-material/QrCode2Rounded';
import qrcode from 'qrcode';
import { useTranslation } from "react-i18next";
import QualityCheckRejectProcee from "../qc/QCRejectReelProcess";
import LabelReamDetails from "../labels/Ream";
import CloseIcon from '@mui/icons-material/Close';
import GlobalConfig from "../../../config/date/GlobalConfig";
import Searchicon from '@mui/icons-material/Search';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddIcon from '@mui/icons-material/Add';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

import ListAltIcon from '@mui/icons-material/ListAlt';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import RefreshIcon from '@mui/icons-material/Refresh';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import ArticleIcon from '@mui/icons-material/Article';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import { hasPermission } from "../../../components/user-permission/AuthorizationParameter";
import useUserPermissions from "../../../components/user-permission/UserPermission";
import { ExpandMore, ExpandLess, DoubleArrowRounded } from '@mui/icons-material';
import InfoIcon from '@mui/icons-material/Info';
import CustomTableContainer from "../../../Layout/CustomTableContainer";
import SkeletonTableLoader from "../../../components/table/SkeletonTableLoader";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import ResponsiveBox from "../../../components/form/ResponsiveScrollBox";
import TableFilterRow from "../../../components/table/TableFilterRow";
import ReportReamPunchingWIPReamList from "../reports/ReportReamPunchingWIPReamList";
import useRemarks from "../../../hooks/common/useRemarks";
import AddRemarks from "../../master/AddRemarks";

const ReamLabel = ({ handleBackWinderMachineEntry }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t, i18n } = useTranslation();

    const [orderFromDate, setOrderFromDate] = useState(dayjs());
    const [orderToDate, setOrderToDate] = useState(dayjs());

    const [sheeterChildRoll, setSheeterChildRoll] = useState([]);
    const [sheeterSelectedChildRoll, setSheeterSelectedChildRoll] = useState(null);
    const [selectedSheeterChildRollDetail, setSelectedSheeterChildRollDetail] = useState([]);

    // message 
    const [sheeterMsgOpen, setSheeterMsgOpen] = useState(false);
    const [sheeterSeverityvalue, setSheeterSeverityvalue] = useState('info');
    const [sheeterMessageValue, setSheeterMessageValue] = useState('');
    const [sheeterAlertTitleValue, setSheeterAlertTitleValue] = useState('');
    const [rows, setRows] = useState(/* initial rows */);

    // pallet details
    const [palletID, setPalletID] = useState(0);
    const [palletCode, setPalletCode] = useState('');
    const [palletStatus, setPalletStatus] = useState('');
    const [lotNumber, setLotNumber] = useState(0);
    const [price, setPrice] = useState(0);
    const [quality, setQuality] = useState('');
    const [gsm, setGSM] = useState('');
    const [finisherNumber, setFinisherNumber] = useState('');
    const [numberofReams, setNumberOfReams] = useState(0);
    const [lossReams, setlossReams] = useState(0);
    const [size, setSize] = useState('');
    const [jumboNumber, setJumboNumber] = useState('');
    const [numberofSheets, setNumberOfSheets] = useState(0);
    const [label, setLabel] = useState('');
    const [reamWeignt, setReamWeight] = useState(0);
    const [lReamWeignt, setLReamWeight] = useState(0);
    const [allocatedSheets, setAllocatedSheets] = useState(0);
    const [palletWeight, setPalletWeight] = useState(0);
    const [palletWeightInKgs, setPalletWeightInKgs] = useState('');
    const [releaseNumber, setReleaseNumber] = useState('');


    const [approvedPalletNumber, setApprovedPalletNumber] = useState([]);
    const [totalReams, setTotalReams] = useState(0);
    const [balanceSheet, setBalanceSheet] = useState(0);
    const [disableSaveBtn, setDisableSaveBtn] = useState(false);
    const [disbleSheetValue, setDisbleSheetValue] = useState(false);
    const [disableDeleteBtn, setDisableDeleteBtn] = useState(false);

    const [selectedReamDetails, setSelectedReamDetails] = useState(null);
    const [viewSheeterchildRollDetail, setviewSheeterchildRollDetail] = useState(false);
    // table data view 
    const sizecolumns = ['SNo', 'ReamNumber', 'Ream Weight', 'Sheets', 'Status'];
    const [selectedReam, setSelectedReam] = useState(null);
    const [selectedReamDetailsQR, setSelectedReamDetailsQR] = useState(null);
    const [viewQRCodeDetails, setViewQRCodeDetails] = useState(false);
    const [viewReamLabeling, setViewReamLabeling] = useState(false);
    const [selectedButton, setSelectedButton] = useState(null);
    const [viewReamsList, setViewReamsList] = useState(false);

    const [reamList, setReamList] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState('All');

    // reject reason
    const [rejectReason, setRejectReason] = useState([]);
    const [selectedReason, setSelectedReason] = useState([]);
    const [rejectProductType, setRejectProductType] = useState(null);
    const [rejectStatus, setRejectStatus] = useState(false);
    const [rejectReasonID, setRejectReasonID] = useState(0);
    const [rejectRemarks, setRejectRemarks] = useState(null);
    const [enableReject, setEnableReject] = useState(false);
    const [enableReverseProcess, setEnableReverseProcess] = useState(true);
    const [period, setPeriod] = useState('Today');
    const [FromDate, setFromDate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day').format('DD/MMM/YYYY'));
    const [ToDate, setToDate] = useState(dayjs().format('DD/MMM/YYYY'));

    const [selectedRows, setSelectedRows] = useState([]);


    const [errorMessage, setErrorMessage] = useState('');
    const [shiftdate_errorMessage, setshiftdate_errorMessage] = useState('');

    const [shiftCodes, setShiftCodes] = useState([]);
    const [winderOperators, setWinderOperators] = useState('');
    const [winderShiftCode, setWinderShiftCode] = useState('');
    const [winderShiftID, setWinderShiftID] = useState(0);
    const [winderShiftDate, setWinderShiftDate] = useState(dayjs());
    const [shiftDate, setShiftDate] = useState(dayjs());
    const [isDataLoaded, setIsDataLoaded] = useState(false);

    // OPERATORS
    const [operator, setOperator] = useState([]);
    const [selectedOperator, setSelectedOperator] = useState([]);
    const [selectedOperatorName, setSelectedOperatorName] = useState([]);
    const [operatorID, setOperatorID] = useState([]);
    const [isOperatorDataLoaded, setIsOperatorDataLoaded] = useState(false);

    const [selectedSetNumberStatus, SetSelectedSetNumberStatus] = useState(null);
    const [setNumberList, setSetNumberList] = useState([]);
    const [disableNumberofSheets, setDisableNumberofSheets] = useState(false);

    const [sheeterNoOfSheets, setSheeterNoOfSheets] = useState(0);
    const [fNo, setFNo] = useState(0);
    const [viewReamQRCode, setViewReamQRCode] = useState(false);
    const [selectedReamRows, setSelectedReamRows] = useState([]);

    const [summaryList, setSummaryList] = useState([]);


    // State for first menu
    const [anchorElFirst, setAnchorElFirst] = useState(null);
    const [selectedOptionFirst, setSelectedOptionFirst] = useState('Ream Punching Summary');
    const openFirst = Boolean(anchorElFirst);

    // State for second menu
    const [anchorElSecond, setAnchorElSecond] = useState(null);
    // const [selectedOptionSecond, setSelectedOptionSecond] = useState('');
    const openSecond = Boolean(anchorElSecond);
    const userPermissions = useUserPermissions();



    // set number of sheets 
    const [isGrossWeight, setIsGrossWeight] = useState(false);

    const [actualReamProduction, setActualReamProduction] = useState(0);
    const [disableReelWiseSheetInput, setdisableReelWiseSheetInput] = useState(false);



    const [width, setWidth] = useState(0);
    const [length, setLength] = useState(0);
    const [selectedOrderItems, SetselectedOrderItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [progress, setProgress] = React.useState(0);
    const [buffer, setBuffer] = React.useState(10);
    const [loadingOrderItemDet, setLoadingOrderItemDet] = useState(false);
    const [recordsPerPage, setRecordsPerPage] = useState(20); // Records per page

    const pageCount = Math.ceil(summaryList.length / recordsPerPage);
    const [currentPage, setCurrentPage] = useState(1);

    const [filterIndentno, setFilterIndentno] = useState('');
    const [indentNoList, setIndentNoList] = useState([]);

    const [expandedRow, setExpandedRow] = useState(null);  // Track which row is expanded
    const [expandedData, setExpandedData] = useState({});
    const [FromShiftDate, setFromShiftDate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day').format('DD/MMM/YYYY'));
    const [ToShiftDate, setToShiftDate] = useState(dayjs().format('DD/MMM/YYYY'));

    // Define the state for your form data
    const [reamFormData, setReamFormData] = useState([]);
    const [selectedReelList, setSelectedReelList] = useState([]);
    const [selectedReamList, setSelectedReamList] = useState([]);
    // Function to update a specific field for a specific ream
    const [openWIPListModal, setOpenWIPListModal] = useState(false);
    // remarks   
    const [openAddRemark, setOpenAddRemark] = useState(false);

    // dummy ids
    const moduledetails = userPermissions.find(
        (m) =>
            m.module_name === "Ream Punching" &&
            m.parent_module_name === "Production"
    );

    const { remarkOptions, loadingRemarks, refetchRemarks } = useRemarks(moduledetails);


    // Handlers for AddRemarks dialog
    const handleOpenAddRemark = () => setOpenAddRemark(true);


    const handleCloseAddRemark = () => {
        setOpenAddRemark(false);
        refetchRemarks();
    };

    // Correct Handlers for the modal
    const handleOpenWIPListModal = () => {
        setOpenWIPListModal(true);
    };

    const handleCloseWIPListModal = () => {
        setOpenWIPListModal(false);
    };

    const handleBackSheeterMachineEntry = () => {
        setOpenWIPListModal(false);
    };

    useEffect(() => {

        let test = reamFormData;

        setReamFormData(prev => {
            const next = [];

            reamList.forEach((r, index) => {
                const existing = prev.find(p => p.id_reel === r.cr_number);

                next.push({
                    id_reel: r.cr_number,
                    sheetCount: existing?.sheetCount ?? r.no_of_sheets ?? "",
                    remarks: existing?.remarks ?? r.winder_remarks ?? "",
                    repulp_qty: existing?.repulp_qty ?? r.repulp_qty ?? "",
                    grade: existing?.grade ?? r.grade ?? "",

                });
            });

            return next;
        });
    }, [reamList]);

    const updateReamField = (reelId, fieldName, value) => {
        setReamFormData(prevData => {
            const newData = [...prevData];
            const reelIndex = newData.findIndex(item => item.id_reel === reelId);

            if (reelIndex !== -1) {
                newData[reelIndex] = {
                    ...newData[reelIndex],
                    [fieldName]: value
                };
            } else {
                newData.push({
                    id_reel: reelId,
                    [fieldName]: value
                });
            }
            return newData;
        });
    };


    // Function to update a specific field for a specific ream
    const updateReamField1 = (reamId, fieldName, value) => {
        setReamFormData((prevData) => {
            const newData = [...prevData];
            const reamIndex = newData.findIndex((item) => item.id_ream === reamId);

            if (reamIndex !== -1) {
                let updated = { ...newData[reamIndex], [fieldName]: value };

                // ✅ Auto-calc Production Qty when no_of_reams changes
                if (fieldName === "no_of_reams") {
                    const reams = parseInt(value) || 0;
                    updated.no_of_reams = reams;
                    updated.produced_qty = reams * sheeterNoOfSheets;
                }

                newData[reamIndex] = updated;
            } else {
                // Add new item if it doesn't exist
                let newItem = { id_ream: reamId, [fieldName]: value };

                if (fieldName === "no_of_reams") {
                    const reams = parseInt(value) || 0;
                    newItem.no_of_reams = reams;
                    newItem.produced_qty = reams * sheeterNoOfSheets;
                }

                newData.push(newItem);
            }

            return newData;
        });
    };

    // Placeholder for other state and logic from your component
    const disableReamWiseSheetInput = false;
    //const colors = {}; // Assume colors are defined
    const actualNoOfSheetsProduced = 0; // Assume this is calculated


    const handleExpandRow = async (row) => {
        const { indent_no } = row;
        // Toggle expansion
        if (expandedRow === indent_no) {
            setExpandedRow(null);
            return;
        }


        try {

            const p_frommodate = dayjs(FromDate).format('YYYY-MM-DD hh:mm:ss');
            const p_tomodate = dayjs(ToDate).format('YYYY-MM-DD hh:mm:ss');

            const para = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
                p_indent_no: row.indent_no,
                p_frommodate,
                p_tomodate
            };

            callApi(API_ENDPOINTS.PROD_MANAGEMENT_GetPalletProductionBasedOnCONumberAPI, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setExpandedData((prev) => ({ ...prev, [indent_no]: data }));
                        setExpandedRow(indent_no);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });

        } catch (error) {
            console.error("Failed to fetch expanded row data", error);
        }

    };

    const handleIndentNoChange = (event, value) => {
        if (value !== undefined && value != null) {
            setFilterIndentno(value);
            LoadOrderItemDetailsFilterByCONumber(value.indent_no);
        }
        else {
            setFilterIndentno('');
            LoadOrderItemDetails();
        }
    }

    const fetchIndentNo = async () => {
        const para = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 0,
        }

        try {
            const data = await callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_DISTINCT_ORDERITEM_REAM_PUNCHING, 'POST', { 'Content-Type': 'application/json' }, para);
            if (data?.length > 0) {
                setIndentNoList(data);
            }
        }
        catch (error) {
            alert(error);
        }
    }


    useEffect(() => {
        fetchIndentNo();
    }, [])



    const logoinput = useState({
        logo: process.env.PUBLIC_URL + '/papyrus3602.png',
    });

    useEffect(() => {
        if (!isGrossWeight) {
            const para = {
                p_companyid: localStorage.getItem('companyid'),
                p_id_default_value: 3
            }

            callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_DEFAULT_VALUES, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(result => {
                    if (result && result.length > 0) {

                        if (result[0].int_value > 0) {
                            //setSheeterNoOfSheets(result[0].int_value);
                            if (sheeterNoOfSheets === 0) {
                                setSheeterNoOfSheets(result[0].int_value);
                            }
                        }
                        else {
                            alert('Please set default number of sheets in reams value');
                        }

                    }
                })
                .catch(error => {
                    alert(error.message);
                });
        }
    }, [isGrossWeight]);





    // Handlers for first menu
    const handleMenuClickFirst = (event) => {
        setAnchorElFirst(event.currentTarget);
    };

    const handleMenuCloseFirst = () => {
        setAnchorElFirst(null);
    };

    const handleMenuItemClickFirst = (option) => {
        setSelectedOptionFirst(option); // Update the selected option
        handleMenuCloseFirst();

        if (option === 'All Child Roll List') {
            setSelectedStatus('All');
        }
        else if (option === 'Unweighted Reels') {
            setSelectedStatus('Booked');
        }
        else if (option === 'FG Child Roll') {
            setSelectedStatus('fg');
        }
        else if (option === 'Inprogress Child Roll') {
            setSelectedStatus('wip');
        }
        else if (option === 'Cancelled Child Roll') {
            setSelectedStatus('cancelled');
        }


        setAnchorElFirst(null);
    };

    // Handlers for second menu
    const handleMenuClickSecond = (event) => {
        setAnchorElSecond(event.currentTarget);
    };

    const handleMenuCloseSecond = () => {
        setAnchorElSecond(null);
    };

    const handleMenuItemClickSecond = (option) => {
        // setSelectedOptionSecond(option); // Update the selected option
        handleMenuCloseSecond();
    };

    const handleShowNewVendor = () => {
        setJobID(0);
        setViewJob(false);
        setViewReamQRCode(false);
        setNewJob(true);
        setviewReamProcess(false);
        setViewLineItemList(true);
        setviewPalletList(false);
    }


    const updateRows = (updatedRows) => {
        setRows(updatedRows);
        setApprovedPalletNumber(updatedRows)
    };


    const callback = () => {
        handleBackWinderMachineEntry();
    };

    const handleDateChange2 = (date) => {
        setFromDate(dayjs(date));
    };

    const handleDateChange1 = (date) => {
        setToDate(dayjs(date));
    };

    const [editMode, setEditMode] = useState(false);

    // filter data new concept
    const [filters, setFilters] = useState({
        cr_number: '',
        plt_number: '',
        indent_no: '',
        shift_code: ''
    });

    // get and user and company details
    const [CompanyID, setCompanyID] = useState(0);
    const [userID, setUserID] = useState('');

    useEffect(() => {
        const retrievedUserID = localStorage.getItem('userID');
        setUserID(retrievedUserID);
        if (retrievedUserID) {
            setCompanyID(localStorage.getItem('companyid'));
        }
    }, []); // Empty dependency array to run only once on mount

    const [isreamCounted, setreamCounted] = useState(false);

    useEffect(() => {
        if (!isreamCounted) {
            if (sheeterNoOfSheets !== 0 && allocatedSheets !== 0) {
                calculateReamsCount(sheeterNoOfSheets);
                setreamCounted(true);
            }
        }
    }, [sheeterNoOfSheets, allocatedSheets]);
    //save grid items //lakshmi
    useEffect(() => {
        if (selectedReelList.length > 0) {
            setReamFormData(prevReams => {
                const next = [];

                selectedReelList.forEach(ream => {
                    if (!ream?.id_ream) return; // ❌ skip invalid rows

                    const existing = prevReams.find(p => p.id_ream === ream.id_ream);

                    next.push({
                        id_ream: ream.id_ream,
                        reamcount: existing?.sheetCount ?? ream.ream_count ?? "",
                        remarks: existing?.remarks ?? ream.remarks ?? "",
                        repulp_qty: existing?.repulp_qty ?? ream.repulp_qty ?? "",
                        grade: existing?.grade ?? ream.grade ?? "",
                    });
                });

                return next;
            });
        } else {
            setReamFormData([]);
        }
    }, [selectedReelList]);


    const calculateReamsCount = (sheets) => {
        // calculate number of reams
        let numberofReams = parseInt(allocatedSheets / sheets);
        setNumberOfReams(numberofReams); // convert to integer

        let balancesheets = allocatedSheets - (numberofReams * sheets);
        let chk_orginal = parseInt(allocatedSheets);
        let lreams = 0;
        setlossReams(0);
        if (balancesheets < chk_orginal) {
            if (balancesheets > 0) {
                setlossReams(1);
                lreams = 1;
            }

        }

        let ReamWeight = (palletWeight / allocatedSheets) * sheets;

        let LReamwt = (palletWeight / allocatedSheets) * balancesheets; //(palletWeight - (ReamWeight * numberofReams));
        // LReamwt = parseFloat(LReamwt.toFixed(GlobalConfig.DecimalPointsReamWeight));

        LReamwt = Math.round(LReamwt * GlobalConfig.DecimalPointsReamWeight) / GlobalConfig.DecimalPointsReamWeight;


        setLReamWeight(LReamwt)


        ReamWeight = ReamWeightCalcualtion(sheets);

        setReamWeight(ReamWeight);
        setTotalReams(numberofReams + lossReams);
        setBalanceSheet(balancesheets);
    }

    const validateReamFormData = (reamFormData) => {
        for (let i = 0; i < reamFormData.length; i++) {
            const row = reamFormData[i];

            if (!row.grade || row.grade.trim() === "") {
                return {
                    ok: false,
                    message: `Grade is missing for Reel No: ${row.id_reel}`
                };
            }
        }

        return { ok: true };
    };

    // Wrap callApi to handle HTTP errors in .then()
    const handleApiCall = async (endpoint, method, headers, body) => {
        try {
            return await callApi(endpoint, method, headers, body);
        } catch (error) {
            // Parse HTTP error response
            if (error.message.includes('HTTP Error! Status: 500')) {
                // Fetch again to get error details (since callApi throws)
                const response = await fetch(endpoint, {
                    method,
                    headers,
                    body: JSON.stringify(body)
                });
                const errorData = await response.json();

                // Return error object instead of throwing
                return {
                    status: 500,
                    error: true,
                    message: errorData.message || errorData.error || 'Server error',
                    data: errorData
                };
            }
            // Re-throw non-500 errors
            throw error;
        }
    };




    // save reams 
    const createReams = async (mode) => {


        if (numberofReams === 0 && sheeterNoOfSheets === 0) {
            setSheeterSeverityvalue('warning');
            setSheeterMessageValue('No Reams Available to create.');
            setSheeterAlertTitleValue('Warning');
            setSheeterMsgOpen(true);

            return;
        }

        if (fNo === 0) {
            setSheeterSeverityvalue('warning');
            setSheeterMessageValue('Please set F.No.');
            setSheeterAlertTitleValue('Warning');
            setSheeterMsgOpen(true);
            return;
        }

        if (sheetCounts.length === 0) {
            setSheeterSeverityvalue('warning');
            setSheeterMessageValue('Please enter no of ream in each child reelno.');
            setSheeterAlertTitleValue('Warning');
            setSheeterMsgOpen(true);
            return;
        }

        if (reamWeignt === 0) {
            setSheeterSeverityvalue('warning');
            setSheeterMessageValue('Please check the Ream Weight is not calculated.');
            setSheeterAlertTitleValue('Warning');
            setSheeterMsgOpen(true);
            return;
        }

        // Check if all rows in sheetCounts have a sheetCount greater than 0
        const allValid = sheetCounts.every((row) => row.sheetCount > 0);

        if (selectedUniqueReelList.length > sheetCounts.length) {
            setSheeterSeverityvalue('error');
            setSheeterMessageValue('All child reels must have a reams greater than 0.');
            setSheeterAlertTitleValue('Error');
            setSheeterMsgOpen(true);
            return;
        }

        if (!allValid) {
            setSheeterSeverityvalue('error');
            setSheeterMessageValue('All child reels must have a reams greater than 0.');
            setSheeterAlertTitleValue('Error');
            setSheeterMsgOpen(true);
            return;
        }

        const userID = localStorage.getItem('userID');
        if (!userID || userID === '0') {
            setSheeterSeverityvalue('warning');
            setSheeterMessageValue('User session expired. Please login again.');
            setSheeterAlertTitleValue('Warning');
            setSheeterMsgOpen(true);
            return;
        }

        const validation = validateReamFormData(reamFormData);

        if (!validation.ok) {

            setSheeterSeverityvalue('warning');
            setSheeterMessageValue(validation.message);
            setSheeterAlertTitleValue('Warning');
            setSheeterMsgOpen(true);
            return;
        }

        // Merge sheetCounts + reamFormData by id_reel
        const mergedReelData = sheetCounts.map(sheet => {
            const winder = reamFormData.find(w => w.id_reel === sheet.id_reel) || {};
            return { ...sheet, ...winder };
        });

        const parameter = {
            p_companyid: localStorage.getItem('companyid'),
            p_plant_id: 1,
            p_shift_id: winderShiftID,
            p_shift_date: dayjs(shiftDate).format('YYYY-MM-DD hh:mm:ss'),
            p_id_operator: operatorID,
            p_pallet_list: selectedReelList,
            p_total_sheets: numberofSheets,
            p_total_reams: numberofReams,
            p_ream_sheets: sheeterNoOfSheets,
            p_ream_weight: reamWeignt,
            p_lose_reams: lossReams,
            p_lose_ream_sheets: balanceSheet,
            p_lose_ream_weight: lReamWeignt,
            p_user: localStorage.getItem('userID'),
            p_fno: fNo,
            p_no_reams_in_reels: sheetCounts,
            p_winder_details: reamFormData,
            p_mode: mode,
            p_id_ream_hdr: jobID

        };
        await  handleApiCall(API_ENDPOINTS.PROD_MANAGEMENT_CREATE_REAM_USING_MULTIPLE_PALLET, 'POST', { 'Content-Type': 'application/json' }, parameter)
         .then(response => {
                // Check if response has error status first
                if (response.error || (response.status && response.status !== 200)) {
                    setSheeterSeverityvalue('error');
                    setSheeterMessageValue(`Server Error: ${response.message}`);
                    setSheeterAlertTitleValue('Error');
                    setSheeterMsgOpen(true);
                    return;
                }

                if (response && response.length > 0) {
                    setApprovedPalletNumber(response);
                    //setviewSheeterchildRollSummaryDetail(true);             

                    setSheeterMessageValue('Ream number created .');
                    if (mode === 1) {
                        setSheeterMessageValue('Ream Job Details Updated successfully .');
                    }
                    setSheeterSeverityvalue('success');
                    setSheeterAlertTitleValue('Success');
                    setSheeterMsgOpen(true);


                    setViewReamsList(true);

                    setDisbleSheetValue(true);
                    setPalletStatus('Completed')

                    if (mode === 0) {
                        setDisableSaveBtn(true);
                    }

                    let id_bundle_hdr = response[0].id_hdr;


                    const reamFilter = {
                        p_companyid: localStorage.getItem('companyid'),
                        p_ream_number: '',
                        p_mode: 1,
                        p_pallet_id: id_bundle_hdr
                    };

                    callApi(API_ENDPOINTS.PROD_MANAGEMENT_SEARCH_GET_REAM_DETAIL, 'POST', { 'Content-Type': 'application/json' }, reamFilter)
                        .then(reamdata => {
                            if (reamdata && reamdata.length > 0) {
                                setReamList(reamdata);
                                setViewReamQRCode(true);
                            }
                        })
                        .catch(error => {
                            alert(error.message);
                        });


                }
                else {
                    if (mode === 0) {
                        setSheeterSeverityvalue('error');
                        setSheeterMessageValue('Unable create Reams Number.');
                        setSheeterAlertTitleValue('Error');
                        setSheeterMsgOpen(true);
                    }
                    else {
                        setSheeterSeverityvalue('warning');
                        setSheeterMessageValue('Cannot update the job details, because reams are already used in bundles (or) reampallet');
                        setSheeterAlertTitleValue('Warning');
                        setSheeterMsgOpen(true);
                    }
                    //setviewSheeterchildRollSummaryDetail(false);
                }
            })
            .catch(error => {
                alert(error.message);
                // Update state with error message        
                setSheeterSeverityvalue('error');
                  setSheeterMessageValue(error.message || 'Network error. Please try again.');
                setSheeterAlertTitleValue('Error');
                setSheeterMsgOpen(true);

            });
    }


    const DeleteReamProductionJobDetails = () => {
        if (!hasPermission(userPermissions, "Ream Punching", "Delete")) {
            alert("Access denied. You don’t have permission to delete this job.");
            return; // Exit the function if permission is not granted
        }

        const confirmDelete = window.confirm(`Are you sure you want to delete the entire job ${jobID}?`);

        if (confirmDelete) {
            if (jobID === 0) {
                setSheeterSeverityvalue('warning');
                setSheeterMessageValue('Please select the Job Details to delete.');
                setSheeterAlertTitleValue('Warning');
                setSheeterMsgOpen(true);
                return;
            }

            const parameter = {
                p_companyid: localStorage.getItem('companyid'),
                p_plant_id: 1,
                p_id_ream_hdr: jobID,
                p_user: localStorage.getItem('userID'),
            };

            // create reams                   
            callApi(API_ENDPOINTS.PROD_MANAGEMENT_DeleteReamProductionJOB, 'POST', { 'Content-Type': 'application/json' }, parameter)
                .then(data => {
                    if (data && data.length > 0) {

                        if (data[0].status === 'success') {

                            LoadJobList();

                            setviewReamProcess(false);
                            setviewPalletList(true);
                            setViewLineItemList(true);

                            setSelectedChip('');
                            setViewJob(true);
                            setNewJob(false);

                            alert('Ream Job Deleted successfully.')
                        }
                        else {
                            setSheeterSeverityvalue('warning');
                            setSheeterMessageValue(data[0].message);
                            setSheeterAlertTitleValue('Warning');
                            setSheeterMsgOpen(true);
                        }


                    }
                    else {
                        setSheeterSeverityvalue('error');
                        setSheeterMessageValue('Unable to delete the Ream Job.');
                        setSheeterAlertTitleValue('Error');
                        setSheeterMsgOpen(true);
                    }
                })
                .catch(error => {
                    alert(error.message);
                    // Update state with error message        
                    setSheeterSeverityvalue('error');
                    setSheeterMessageValue(error.message);
                    setSheeterAlertTitleValue('Error');
                    setSheeterMsgOpen(true);

                });
        }


    }

    const AlertMessage = (severity, message, title, open) => {
        setSheeterSeverityvalue(severity);
        setSheeterMessageValue(message);
        setSheeterAlertTitleValue(title);
        setSheeterMsgOpen(open);
    };

    const DeleteSelectedReamProductionJobDetails = () => {
        if (!hasPermission(userPermissions, "Ream Punching", "Delete")) {
            alert("Access denied. You don’t have permission to delete the reams.");
            return; // Exit the function if permission is not granted
        }

        let printselectedReamDetails = reamList;
        printselectedReamDetails = reamList.filter((ream) => selectedReamRows.includes(ream.ream_id));

        if (jobID === 0) {
            AlertMessage('warning', 'Please select the Job Details to delete.', 'Warning', true);
            return;
        }

        if (printselectedReamDetails.length === 0) {
            AlertMessage('warning', 'Please select at least one ream code to delete', 'Warning', true);
            return;
        }

        if (reamList.length === printselectedReamDetails.length) {
            AlertMessage('warning', 'Cannot delete all reams in a Job. Please delete the entire job.', 'Warning', true);
            return;
        }

        const confirmDelete = window.confirm(`Are you sure you want to delete the selected ream in job details?`);

        if (confirmDelete) {
            setSheeterMsgOpen(false);

            const parameter = {
                p_companyid: localStorage.getItem('companyid'),
                p_plant_id: 1,
                p_selected_reams: printselectedReamDetails,
                p_user: localStorage.getItem('userID'),
            };

            // create reams                   
            callApi(API_ENDPOINTS.PROD_MANAGEMENT_DeleteSelectedReamsInReamJob, 'POST', { 'Content-Type': 'application/json' }, parameter)
                .then(data => {
                    if (data && data.length > 0) {
                        if (data === 'Selected reams deleted successfully.') {
                            GetProducedReamList();
                            AlertMessage('success', data, 'Success', true);
                        }
                        else {
                            AlertMessage('warning', data, 'Warning', true);
                        }
                    }
                    else {
                        AlertMessage('error', 'Unable to delete the Selected Reams In Job.', 'Error', true);
                    }
                })
                .catch(error => {
                    AlertMessage('error', error.message, 'Error', true);
                });
        }


    }
    const ReverseReams = () => {
        setSheeterMsgOpen(false);
        let isvalid = true;
        let validation_msg = '';

        // validation Process

        if (numberofSheets === 0) {
            validation_msg += 'Please Enter Number of Sheets in Reams.\n';
            isvalid = false;
        }

        // Remove trailing newline character if any
        validation_msg = validation_msg.trim();

        if (isvalid === true) {

            const orderData = {
                p_companyid: localStorage.getItem('companyid'),
                p_total_reams: totalReams,

            };


            // GET REAM NUMBER
            callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_REAM_NUMBER, 'POST', { 'Content-Type': 'application/json' }, orderData)
                .then(data => {

                    // update ream number to ream table
                    if (data && data.length > 0) {
                        // preceed to add new reams
                        console.table(data);
                        let ream_number_end = data[0].lot_number;
                        let ream_number_start = ream_number_end - totalReams;


                        const reamData = {
                            p_companyid: localStorage.getItem('companyid'),
                            p_plant_id: 1,
                            p_total_reams: numberofReams,
                            p_pallet_id: palletID,
                            p_number_of_sheets: numberofSheets,
                            p_loss_reams: lossReams,
                            p_loss_reams_sheets: balanceSheet,
                            p_created_by: localStorage.getItem('userID'),
                            p_reject_ream_status: false,
                            p_ream_number_start: ream_number_start,
                            p_ream_weight: reamWeignt,
                            p_l_ream_weight: lReamWeignt,
                            p_process_id: 1
                        };


                        // create reams                   
                        callApi(API_ENDPOINTS.PROD_MANAGEMENT_CREATE_REAM, 'POST', { 'Content-Type': 'application/json' }, reamData)
                            .then(data => {
                                if (data && data.length > 0) {
                                    // setApprovedPalletNumber(data);
                                    // //setviewSheeterchildRollSummaryDetail(true);
                                    // setSheeterSeverityvalue('info');
                                    // setSheeterMessageValue('Ream number created .');
                                    // setSheeterAlertTitleValue('info');
                                    // setSheeterMsgOpen(true);

                                    // setViewReamsList(true);
                                    // setDisableSaveBtn(true);
                                    // setDisbleSheetValue(true);
                                    // setPalletStatus('Completed')
                                    setSheeterSeverityvalue('info');
                                    setSheeterMessageValue('Ream number reverse process failed.');
                                    setSheeterAlertTitleValue('info');
                                    setSheeterMsgOpen(true);

                                }
                                else {
                                    setApprovedPalletNumber([]);
                                    setSheeterSeverityvalue('info');
                                    setSheeterMessageValue('Ream number reverse process success.');
                                    setSheeterAlertTitleValue('info');
                                    setSheeterMsgOpen(true);
                                    setViewReamsList(false);
                                    setDisableSaveBtn(false);
                                    setDisbleSheetValue(false);
                                    setPalletStatus('wip')
                                    //setviewSheeterchildRollSummaryDetail(false);
                                }
                            })
                            .catch(error => {
                                alert(error.message);
                                // Update state with error message        
                                setSheeterSeverityvalue('error');
                                setSheeterMessageValue(error.message);
                                setSheeterAlertTitleValue('Error');
                                setSheeterMsgOpen(true);
                                //setviewSheeterchildRollSummaryDetail(false);
                            });
                    }
                    else {
                        // set error message
                        alert('no data found..');
                    }

                })
                .catch(error => {
                    // Update state with error message       
                    setSheeterSeverityvalue('error');
                    setSheeterMessageValue(error.message);
                    setSheeterAlertTitleValue('Error');
                    setSheeterMsgOpen(true);
                });

        }
        else {
            setSheeterSeverityvalue('warning');
            setSheeterMessageValue(validation_msg);
            setSheeterAlertTitleValue('Error');
            setSheeterMsgOpen(true);
        }

    };


    const filterData = (filter) => {
        let fromDate, toDate;
        switch (filter) {
            case 'All':
                fromDate = dayjs().subtract(4, 'year').startOf('year').format('YYYY-MM-DD HH:mm:ss');
                toDate = dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss');
                break;
            case 'Today':
                fromDate = dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss');
                toDate = dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss');
                break;
            case 'This Week':
                fromDate = dayjs().startOf('week').format('YYYY-MM-DD HH:mm:ss');
                toDate = dayjs().endOf('week').format('YYYY-MM-DD HH:mm:ss');
                break;
            case 'This Month':
                fromDate = dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss');
                toDate = dayjs().endOf('month').format('YYYY-MM-DD HH:mm:ss');
                break;
            case 'This Quarter':
                fromDate = dayjs().startOf('quarter').format('YYYY-MM-DD HH:mm:ss');
                toDate = dayjs().endOf('quarter').format('YYYY-MM-DD HH:mm:ss');
                break;
            case 'This Year':
                fromDate = dayjs().startOf('year').format('YYYY-MM-DD HH:mm:ss');
                toDate = dayjs().endOf('year').format('YYYY-MM-DD HH:mm:ss');
                break;
            default:
                fromDate = ''; // You can set a default value here
                toDate = ''; // You can set a default value here
                break;
        }

        setSheeterMsgOpen(false);
        setViewReamLabeling(false);
        setShowCard(false);
        setSheeterSelectedChildRoll(null);

        // Date filter
        const p_companyid = localStorage.getItem('companyid');
        const p_frommodate = fromDate;//dayjs(orderFromDate).format('YYYY-MM-DD hh:mm:ss');
        const p_tomodate = toDate;//dayjs(orderToDate).format('YYYY-MM-DD hh:mm:ss');
        const p_filtertype = "ream";
        const p_mono = 1;

        // Collect the values of the controls
        const parameter = {
            p_companyid,
            p_frommodate,
            p_tomodate,
            p_filtertype,
            p_mono,
        };


        // GET APPROVED PALLET LIST
        // callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_APPROVED_PALLET_LIST, 'POST', { 'Content-Type': 'application/json' }, parameter)
        //     .then(data => {
        //         if (data && data.length > 0) {
        //             // Update state with fetched data
        //             setSheeterChildRoll(data);


        //         } else {
        //             // No data found
        //             //setSheeterChildRoll(null);
        //             setSheeterSeverityvalue('info');
        //             setSheeterMessageValue('No Pallets found this date range (' + p_frommodate + ' - ' + p_tomodate + ")");
        //             setSheeterAlertTitleValue('info');
        //             setSheeterMsgOpen(true);
        //         }
        //     })
        //     .catch(error => {
        //         // Update state with error message       
        //         setSheeterSeverityvalue('error');
        //         setSheeterMessageValue(error.message);
        //         setSheeterAlertTitleValue('Error');
        //         setSheeterMsgOpen(true);
        //     });



    };

    const callError = (serverityval, msg, title) => {
        // Update state with error message        
        setSheeterSeverityvalue(serverityval);
        setSheeterMessageValue(msg);
        setSheeterAlertTitleValue(title);
        setSheeterMsgOpen(true);
    };



    const getSelectedReamDetail = (event, value) => {

        if (value && value != null) {
            setSelectedReam(value);
            //const reamDetails = approvedPalletNumber.find(bundle => bundle.ream_number === value.ream_number);
            const reamDetails = reamList.find(bundle => bundle.ream_number === value.ream_number);
            setSelectedReamDetailsQR(reamDetails);
            setViewQRCodeDetails(true);
        }
        else {

            setViewQRCodeDetails(false);
        }
    };

    const [isDataLoadeds, setIsDataLoadeds] = useState(false);

    useEffect(() => {
        if (!isDataLoadeds) {

            LoadJobList();

        }
    }, [isDataLoadeds, FromShiftDate, ToShiftDate, setFromShiftDate, setToShiftDate]);

    const LoadJobList = () => {
        const p_frommodate = dayjs(FromShiftDate).format('YYYY-MM-DD');
        const p_tomodate = dayjs(ToShiftDate).format('YYYY-MM-DD');

        const para = {
            p_companyid: localStorage.getItem('companyid'),
            p_frommodate: p_frommodate,
            p_tomodate: p_tomodate,
        }
        setLoading(true);
        callApi(API_ENDPOINTS.PROD_MANAGEMENT_REAM_PROCESS_LIST, 'POST', { 'Content-Type': 'application/json' }, para)
            .then(data => {
                if (data && data.length > 0) {
                    setSummaryList(data);
                    setLoading(false);
                }
                else { setLoading(false); }
            })
            .catch(error => {
                alert(error.message);
                setLoading(false);
            });
    }

    const [headerData, setheaderData] = useState({
        logo: process.env.PUBLIC_URL + '/ITC_logo.png',

    });

    function formatDate1(dateString) {
        if (!dateString) return ''; // Handle null or undefined date
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0'); // Ensure 2 digits for day
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Ensure 2 digits for month
        const year = date.getFullYear(); // Get full year
        return `${day}/${month}/${year}`;
    }

    const handleButtonClick = async (buttonName) => {
        setSelectedButton(buttonName);
        setSheeterMsgOpen(false);

        // let printselectedPalletDetails = approvedPalletNumber;
        let printselectedReamDetails = reamList;
        let isvalid = true;

        if (printselectedReamDetails.length === 0) {
            isvalid = false;
        } else if (buttonName === "PrintQR" && (!selectedReamDetails || selectedReamDetails.length === 0)) {
            isvalid = false;

            setSheeterSeverityvalue('info');
            setSheeterMessageValue('Please select pallet code to print. ');
            setSheeterAlertTitleValue('info');
            setSheeterMsgOpen(true);
        }

        let company_id = localStorage.getItem('companyid');


        // filter data      
        printselectedReamDetails = reamList.filter((ream) => selectedReamRows.includes(ream.ream_id));

        if (printselectedReamDetails.length === 0) {
            isvalid = false;
            setSheeterSeverityvalue('info');
            setSheeterMessageValue('Please select ream code to print. ');
            setSheeterAlertTitleValue('info');
            setSheeterMsgOpen(true);
            return;
        }


        if (isvalid == true) {
            if (printselectedReamDetails.length > 0) {
                const printWindow = window.open('', '_blank');
                try {
                    // Generate HTML content for each QR code
                    for (const qrCodeValue of printselectedReamDetails) {
                        // Generate QR code data URL
                        const qrDataUrl = await generateQRCode(qrCodeValue.ream_number);
                        // Check if QR code generation was successful
                        if (!qrDataUrl) {
                            console.error('Error generating QR code for value:', qrCodeValue.ream_number);
                            continue; // Skip to the next QR code
                        }


                        if (company_id == '1') {
                            // Write HTML content for the QR code to the print window
                            printWindow.document.write(`
                                    <html>
                                            <head>
                                                <title>Printed Report</title>
                                                <style>
                                                <style>
                                                        body {
                                                            margin: 0;
                                                            padding: 0;
                                                            font-family: Arial, sans-serif;
                                                        }
                                                        .container {
                                                            display: flex;
                                                            align-items: center;
                                                            justify-content: space-between;
                                                            padding: 10px;
                                                            border: 1px solid #ccc;
                                                            box-sizing: border-box;
                                                        }
                                                        .qr-code {
                                                            width: 150px; /* Adjust as needed */
                                                        }
                                                        .bundle-details {
                                                            flex: 1;
                                                            margin-left: 20px; /* Adjust spacing between QR code and bundle details */
                                                        }
                                                        .bundle-details h5 {
                                                            margin: 0;
                                                            font-size: 18px;
                                                        }
                                                        .details-table {
                                                            display: grid;
                                                            grid-template-columns: 150px auto;
                                                            gap: 10px 20px;
                                                            margin-top: 10px;
                                                        }
                                                        .details-table div {
                                                            font-size: 16px;
                                                        }
                                                        .details-table .label {
                                                            font-weight: bold;
                                                        }
                                                        .bundle-details hr {
                                                            margin: 10px 0;
                                                            border: 1px solid #ccc;
                                                        }
                                                        /* Ensure each container goes on a new page */
                                                        .container {
                                                            page-break-after: always;
                                                        }
                                                    </style>
                                            </head>
                                            <body>
                                            <div class="container">
                                            <div>
                                                <img class="qr-code" src="${qrDataUrl}" alt="QR Code" />
                                                <h3>${qrCodeValue.ream_number || 'XXXXXX0123'}</h3>
                                            </div>
                                            <div class="bundle-details">
                                            
                                                    <h5>REAM DETAILS</h5>
                                                    <hr/>
                                            <div class="details-table">
                                                    <div class="label">DATE / SHIFT </div><div>:  ${qrCodeValue.shift_date || ''} / ${qrCodeValue.shift_code || ''}</div>  
                                                    <div class="label">REAM NUMBER</div><div>: ${qrCodeValue.ream_number}</div> 
                                                    <div class="label">PALLET CODE</div><div>: ${qrCodeValue.pallet_code}</div> 
                                                    <div class="label">REEL NUMBER</div><div>: ${qrCodeValue.cr_number}</div> 
                                                    <div class="label">QUALITY</div><div>: ${qrCodeValue.item_code}</div> 
                                                    <div class="label">SIZE</div><div>: ${qrCodeValue.size}</div>  
                                                    <div class="label">GSM</div><div>: ${qrCodeValue.gsm}</div> 
                                                    <div class="label">REAM WEIGHT</div><div>: ${qrCodeValue.ream_weight}</div> 
                                                    <div class="label">NO.OF.SHEETS</div><div>: ${qrCodeValue.no_of_sheets}</div> 
                                                    <div class="label">REMARKS</div><div>:</div>            
                                                
                                                </div>                                           
                                                
                                                
                                            </div>
                                            
                                        </div>
                                            </body>
                                        </html>
                                    
                                        
                                    `);
                        }
                        else if (company_id === '13') {

                            printWindow.document.write(`
                                <html>
                                <head>
                            <title>Printed Report</title>
                            <style>
                                @page {
                                     size: 100mm 25mm; /* Portrait orientation */
                                         margin: 0; /* Remove margins for edge-to-edge printing */
                                }
                                body {
                                    margin: 0;
                                    padding: 0;
                                    font-family: Arial, sans-serif;
                                    display: flex;
                                    flex-wrap: wrap; /* Allows multiple labels on the same page */
                                    align-items: flex-start;
                                    justify-content: flex-start;
                                    
                                    box-sizing: border-box;
                                }
                                .container {
                                    display: flex;
                                    align-items: center;
                                    justify-content: space-between;
                                    width: 100%;
                                    height: 45px;
                                    padding: 0; /* Remove padding from the container */
                                    box-sizing: border-box;
                                }
                                .labelx {
                                    width: 100mm;
                                    height: 25mm;
                                    padding: 2mm; /* Adjust as needed for content alignment */
                                    box-sizing: border-box;
                                   
                                    display: flex;
                                    flex-direction: row;
                                    justify-content: space-between;
                                }
                                .logo {
                                    max-width: 7mm; /* Ensure logo scales within a small area */
                                    height: auto;
                                   
                                }
                                .text-details {
                                    flex: 1;
                                    margin-left: 1mm;
                                    margin-top: 0.2mm;
                                    font-size: 0.4rem;
                                    font-weight: bold;
                                }
                                .text-details p {
                                    margin: 0;
                                    line-height: 1.1; /* Reduce line spacing for compactness */
                                    font-weight: bold;
                                    color: #01579b;
                                }
                                .marketed-by {
                                    text-align: center;
                                    font-size: 0.3rem;
                                    font-weight: bold;
                                    margin-top: 0.5mm; /* Reduce or remove space above */
                                }
                                .marketed-by p {
                                    margin: 0; /* Remove margins from paragraphs */
                                    line-height: 1.1; /* Compact line spacing */
                                }
                                .details-section {
                                    display: grid;
                                    grid-template-columns: auto auto; /* Label and value in two columns */
                                    gap: 0.1mm 0.1mm; /* Reduce spacing between rows and columns */
                                    width: 100%;                                   
                                    margin-top: 0.5mm;
                                    
                                }
                                .details-section .label {
                                    font-weight: bold;
                                    text-align: left;
                                     font-size: 0.7rem;
                                }
                               .details-section .label1 {                                    
                                    text-align: left;
                                     font-weight: bold;
                                     font-size: 0.6rem;
                                }
                                .details-section .value {
                                    text-align: left;
                                    font-size: 0.7rem;
                                }
                                .details-section .value1 {
                                    text-align: left;
                                    font-size: 0.6rem;
                                }
                                .details-section .full-line {
                                    text-align: left; /* Center align the text */
                                    font-size: 0.9rem; /* Adjust font size for readability */
                                    font-weight: bold; /* Bold text for emphasis */
                                    text-transform: uppercase; /* Ensure the text is all caps */
                                    width: 100%; /* Span the full width of the container */
                                    grid-column: 1 / -1; /* Make it span across both columns in the grid */
                                    margin-top: 0mm; /* Optional: Add spacing above for better layout */
                                    white-space: nowrap; /* Prevent wrapping to a new line */
                                }    
                            </style>
                        </head>
                               <body>
                               <div class="labelx">
                               <div class="header-row" ">
                                            <!-- Logo -->
                                            <div class="container">
                                                <!-- Logo Section -->
                                                <div>
                                                   
                                                </div>
        
                                                <!-- Text Details -->
                                                <div class="text-details">
                                                   
                                                </div>
                                            </div>
        
                                            
                                
                                        <!-- Marketed By Section -->
                                        <div class="marketed-by">
                                            
                                        </div>
                              </div>


                         <!-- Details Section -->
                                   <div>
                                        <table style="text-align: left; font-size: 10px; border-collapse: collapse;">
                                            <tr>
                                                <!-- Column 1 -->
                                                <th style="padding-right: 1px;">
                                                    <table style="text-align: left; font-size: 10px;">
                                                        <tr>
                                                            <th>${qrCodeValue.item_code}</th>
                                                        </tr>
                                                        <tr>
                                                            <th>GSM:</th>
                                                            <th>${qrCodeValue.gsm}</th>
                                                        </tr>
                                                        <tr>
                                                            <th>SIZE(cm):</th>
                                                            <th>${qrCodeValue.size}</th>
                                                        </tr>
                                                        <tr>
                                                            <th>NET WT(kg):</th>
                                                            <th>${qrCodeValue.ream_weight}</th>
                                                        </tr>
                                                        <tr>
                                                            <th style="visibility: hidden;">F.NO:</th>
                                                            <th style="visibility: hidden;">${qrCodeValue.fno || 0}</th>
                                                        </tr>
                                                    </table>
                                                </th>

                                                <!-- Column 2 -->
                                                <th>
                                                    <table style="text-align: left; font-size: 10px;">
                                                        <tr>
                                                            <th>DATE:</th>
                                                            <th>${formatDate(qrCodeValue.shift_date)}</th>
                                                        </tr>
                                                        <tr>
                                                            <th>LOT NO:</th>
                                                            <th>${qrCodeValue.pr_number}</th>
                                                        </tr>
                                                        <tr>
                                                            <th></th>
                                                            <th>/ ${qrCodeValue.cr_number}</th>
                                                        </tr>
                                                        <tr>
                                                            <th>NO OF SHEET:</th>
                                                            <th> ${qrCodeValue.no_of_sheets || 0}</th>
                                                        </tr>
                                                        <tr style=" font-size: 12px;">
                                                            <th>MADE IN INDIA</th>
                                                        
                                                        </tr>
                                                    
                                                    </table>
                                                </th>
                                            </tr>
                                        </table>
                                    </div> 
                                                                      
                                        
                                   </div>
                                </body>
                                </html>
                                `);




                        }



                    }
                    // Close the print window and print the report

                    printWindow.document.close();
                    printWindow.print();

                } catch (error) {
                    console.error('Error handling button click:', error);
                }
            }


        }

    };


    //     <div class="details-section">
    //     <div class="label">${qrCodeValue.item_code}</div>
    //     <div class="value"></div>

    //     <div class="label" style="margin-right: 5mm;">GSM: ${qrCodeValue.gsm}</div>
    //     <div class="value"></div>

    //     <div class="label">SIZE (cm): ${qrCodeValue.size}</div>
    //     <div class="value"></div>

    //     <div class="label">NET WT (kg): ${qrCodeValue.ream_weight}</div>
    //     <div class="value"></div>     

    //     <div class="label1">F.NO: ${qrCodeValue.fno || 0}</div>
    //     <div class="value"></div>    
    // </div>

    // <!-- Details Section -->
    // <div class="details-section">                                  
    //     <div class="label">DATE: ${formatDate(qrCodeValue.shift_date)}</div>
    //     <div class="value"></div>

    //     <div class="label">LOT NO: <span style="font-weight: normal;">${qrCodeValue.pr_number} </span> / </div>
    //     <div class="value"><span style="font-weight: normal;">  ${qrCodeValue.cr_number}</span></div>

    //     <div class="label">NO OF SHEET: ${qrCodeValue.no_of_sheets || 0}</div>
    //     <div class="value"></div>

    //     <!-- Fixed for "MADE IN INDIA" -->
    //     <div class="full-line">MADE IN INDIA</div>                              
    // </div>



    // Function to generate QR code as data URL
    const generateQRCode = async (value) => {
        try {
            const qrDataUrl = await qrcode.toDataURL(value);
            return qrDataUrl;
        } catch (error) {
            console.error('Error generating QR code:', error);
            return null;
        }
    };



    const [open, setOpen] = useState(false);
    const [getRejectResult, setGetRejectResult] = useState([]);

    const openpopup = async (buttonName) => {
        setSelectedButton(buttonName);
        if (buttonName == 'ReverseProcess') {
            ReverseReams();
        }
        else if (buttonName == 'RejectChild') {
            setOpen(true);
        }
    }

    const closepopup = () => {
        setOpen(false);
        setSheeterMsgOpen(false);


        let reject_product_type = "Ream";
        let product_code = selectedReamDetailsQR.bundle_number;
        let isvalid = true;

        if (enableReject == false) {
            isvalid = false;
        }
        else if (product_code === "") {
            isvalid = false;
        }
        else if (selectedReamDetailsQR.bundle_number == "") {
            isvalid = false;
        }
        else if (selectedReamDetailsQR.status != "approved") {

            isvalid = false;
            if (selectedReamDetailsQR.status == "rejected") {
                setSheeterSeverityvalue('info');
                setSheeterMessageValue('Ream already rejected');
                setSheeterAlertTitleValue('info');
                setSheeterMsgOpen(true);
            }
            else {
                setSheeterSeverityvalue('info');
                setSheeterMessageValue('We cannot reject this ream. The ream has already been processed for the next stage.');
                setSheeterAlertTitleValue('info');
                setSheeterMsgOpen(true);
            }

        }


        if (isvalid) {
            // call reject reel process
            const parameter = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
                p_reject_product_type: reject_product_type,
                p_product_code: product_code,
                p_rejectReasonID: rejectReasonID,
                p_rejectRemarks: rejectRemarks,
                p_user: localStorage.getItem('userID'),
            };

            callApi(API_ENDPOINTS.DECKL_UPDATE_REJECT_REEL, 'POST', { 'Content-Type': 'application/json' }, parameter)
                .then(data => {
                    if (data && data.length > 0) {
                        setGetRejectResult(data);
                        setSheeterSeverityvalue('info');
                        setSheeterMessageValue('The ream has rejected.');
                        setSheeterAlertTitleValue('info');
                        setSheeterMsgOpen(true);
                        getReamList();
                    }
                })
                .catch(error => {

                });
        }
    }


    const getReamList = () => {
        //parameters
        const reamData = {
            p_companyid: localStorage.getItem('companyid'),
            p_pallet_id: palletID,
        };


        callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_REAM_LIST, 'POST', { 'Content-Type': 'application/json' }, reamData)
            .then(data => {
                if (data && data.length > 0) {
                    setApprovedPalletNumber(data);

                    const orderData = {
                        p_companyid: localStorage.getItem('companyid'),
                        p_ream_number: '',
                        p_mode: 1,
                        p_pallet_id: palletID
                    };

                    callApi(API_ENDPOINTS.PROD_MANAGEMENT_SEARCH_GET_REAM_DETAIL, 'POST', { 'Content-Type': 'application/json' }, orderData)
                        .then(data => {
                            if (data && data.length > 0) {
                                setReamList(data);
                            }
                        })
                        .catch(error => {
                            alert(error.message);
                        });

                }

            })
            .catch(error => {
                alert(error.message);
                // Update state with error message        
                setSheeterSeverityvalue('error');
                setSheeterMessageValue(error.message);
                setSheeterAlertTitleValue('Error');
                setSheeterMsgOpen(true);
                //setviewSheeterchildRollSummaryDetail(false);
            });
    };

    const filteredReamData = reamList.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All') {
            //|| row.status === selectedStatus
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });





    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        const date = new Date(dateString);
        return date.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        }).replace(/ /g, "-"); // Replace spaces with hyphens
    };


    // Load child roll details
    const [childRollDetails, setChildRollDetails] = useState([]);

    const GetLineItemDetails = async (id_child_roll, edit) => {

        if (id_child_roll != 0) {
            try {
                const para = {
                    p_companyid: localStorage.getItem('companyid'),
                    p_id_child_reel: id_child_roll
                };

                // Await the API response
                const data = await callApi(
                    API_ENDPOINTS.WAREHOUSE_GET_STACK_WISE_ALLOCATED_REEL_COMPLETE_DETAIL,
                    'POST',
                    { 'Content-Type': 'application/json' },
                    para
                );

                if (data && data.length > 0) {
                    setChildRollDetails(data);
                    setviewSheeterchildRollDetail(true);

                    // update then hide this
                    if (edit === false) {
                        setNumberOfSheets(data[0].no_of_sheets)
                        calculateReamsCount(data[0].no_of_sheets);
                    }

                }
                else {
                    setviewSheeterchildRollDetail(false);
                }
            } catch (error) {
                alert(error);
            }
        }

    }
    const [showCard, setShowCard] = useState(false);

    const handleHide = () => {
        setShowCard(false);
        // setViewAvailableSlots(true);
        // SetViewAvailableReelList(false);
    };


    const [partyList, setPartyList] = useState([]);

    useEffect(() => {
        // Date filter
        const p_companyid = localStorage.getItem('companyid');
        const p_frommodate = dayjs(FromDate).format('YYYY-MM-DD hh:mm:ss');
        const p_tomodate = dayjs(ToDate).format('YYYY-MM-DD hh:mm:ss');
        const p_filtertype = "";
        const p_mono = 0;

        const orderData = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 1,
            p_release_no: p_mono,
            p_frommodate,
            p_tomodate
        };

        setLoadingOrderItemDet(true);

        callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_PALLET_ORDER_LINE_ITEMS_DETAILS, 'POST', { 'Content-Type': 'application/json' }, orderData)
            .then(data => {
                if (data && data.length > 0) {
                    // Update state with fetched data
                    setPartyList(data);
                    setViewLineItemList(true);
                    setLoadingOrderItemDet(false);
                } else {
                    // No data found
                    setPartyList([]);
                    setViewLineItemList(false);
                    callError('info', 'No data found, Kindly adjust data range.', 'info');
                    setLoadingOrderItemDet(false);
                }
            })
            .catch(error => {
                // Update state with error message        
                callError('error', error.message, 'Error');
                setLoadingOrderItemDet(false);
            });

    }, [FromDate], [ToDate]);


    const LoadOrderItemDetails = () => {
        const p_frommodate = dayjs(FromDate).format('YYYY-MM-DD hh:mm:ss');
        const p_tomodate = dayjs(ToDate).format('YYYY-MM-DD hh:mm:ss');
        const p_mono = 0;

        const orderData = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 1,
            p_release_no: p_mono,
            p_frommodate,
            p_tomodate
        };

        callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_PALLET_ORDER_LINE_ITEMS_DETAILS, 'POST', { 'Content-Type': 'application/json' }, orderData)
            .then(data => {
                if (data && data.length > 0) {
                    // Update state with fetched data
                    setPartyList(data);
                    setViewLineItemList(true);
                } else {
                    // No data found
                    setPartyList([]);
                    setViewLineItemList(false);
                    callError('info', 'No data found, Kindly adjust data range.', 'info');
                }
            })
            .catch(error => {
                // Update state with error message        
                callError('error', error.message, 'Error');
            });
    }

    const LoadOrderItemDetailsFilterByCONumber = (indentno) => {
        const p_frommodate = dayjs(FromDate).format('YYYY-MM-DD hh:mm:ss');
        const p_tomodate = dayjs(ToDate).format('YYYY-MM-DD hh:mm:ss');
        const p_mono = 0;

        const orderData = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 1,
            p_release_no: p_mono,
            p_frommodate,
            p_tomodate,
            p_indent_no: indentno
        };

        callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_PALLET_ORDER_LINE_ITEMS_DETAILS_BY_CO_NUMBER, 'POST', { 'Content-Type': 'application/json' }, orderData)
            .then(data => {
                if (data && data.length > 0) {
                    // Update state with fetched data
                    setPartyList(data);
                    setViewLineItemList(true);
                } else {
                    // No data found
                    setPartyList([]);
                    setViewLineItemList(false);
                    callError('info', 'No data found, Kindly adjust data range.', 'info');
                }
            })
            .catch(error => {
                // Update state with error message        
                callError('error', error.message, 'Error');
            });
    }


    const filteredData = partyList.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });


    useEffect(() => {
        const fetchChildRollDetails = async () => {
            if (period === 'Today') {
                filterData('Today');
            }

        };

        fetchChildRollDetails();

    }, [setPeriod]);

    const [newJob, setNewJob] = useState(false);
    const [viewJob, setViewJob] = useState(true);
    const [viewLineItemList, setViewLineItemList] = useState(false);
    const [viewPalletList, setviewPalletList] = useState(false);
    const [viewReamProcess, setviewReamProcess] = useState(false);
    const [reelList, setReelList] = useState([]);


    const [selectedUniqueReelList, setSelectedUniqueReelList] = useState([]);
    const [jobID, setJobID] = useState(0);

    const [selectedLineItemDetail, setSelectedLineItemDetail] = useState([]);

    const ReamWeightCalcualtion = (sheeterNoOfSheets) => {
        let reamwt;
        // reamwt = ((gsm * width * length) / sheeterNoOfSheets) / 1000;

        reamwt = (gsm * width * length * sheeterNoOfSheets) / 10000000
        // reamwt=9.35;
        // reamwt = parseFloat(reamwt.toFixed(GlobalConfig.DecimalPointsReamWeight));
        reamwt = Math.round(reamwt * GlobalConfig.DecimalPointsReamWeight) / GlobalConfig.DecimalPointsReamWeight;

        return reamwt;
    }

    const handleCallEdit = (row) => {
        SetselectedOrderItems(row);

        setSelectedChip('View Reel List');

        setGSM(row.gsm);
        setWidth(row.d_width);
        setLength(row.d_length);
        if (row.no_of_sheets) {
            setSheeterNoOfSheets(row.no_of_sheets);
        }

        if (row.indent_no && partyList && Array.isArray(partyList)) {
            let lineItems = partyList.filter((l) => l.indent_no === row.indent_no && l.line_no === row.line_no);
            reamCalculation(lineItems);
        }
        const orderData = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 1,
            p_indent_no: row.indent_no,
            p_line_no: row.line_no,
            p_release_no: 0,

        };

        callApi(API_ENDPOINTS.PROD_MANAGEMENT__GET_ORDER_LINE_ITEMS_WISE_PALLET_LIST, 'POST', { 'Content-Type': 'application/json' }, orderData)
            .then(data => {
                if (data && data.length > 0) {
                    const allConverted = data.every(row => row.status === 'converted');
                    if (!allConverted) {
                        setReelList(data);
                        setviewPalletList(true);
                        setViewLineItemList(false);

                        setSheetCounts([]);
                        setSelectedUniqueReelList([]);
                        setSheeterMsgOpen(false);
                    }
                    else {
                        setReelList([]);
                        setviewPalletList(false);
                        callError('info', 'No data found, Kindly adjust data range.', 'info');
                        LoadOrderItemDetails();

                        setSheetCounts([]);
                        setSelectedUniqueReelList([]);
                    }

                } else {
                    // No data found
                    setReelList([]);
                    setviewPalletList(false);
                    callError('info', 'No data found, Kindly adjust data range.', 'info');
                }
            })
            .catch(error => { callError('error', error.message, 'Error'); });

    };

    const reamCalculation = (lineItems) => {
        let sheets = lineItems[0].no_of_sheets;

        // Summing the no_of_sheets using reduce
        //let totalSheets = lineItems.reduce((acc, item) => acc + item.no_of_sheets, 0);


        setSelectedLineItemDetail(lineItems);
        // setSheeterNoOfSheets(sheets); hided for default sheet count 100
    };

    const filteredReelData = reelList.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });

    // const handleSelectAllClick = (event) => {
    //     if (event.target.checked) {
    //         // Exclude rows with status 'converted'
    //         const newSelectedRows = reelList
    //             .filter((row) => row.status !== 'converted') // Exclude 'converted' rows
    //             .map((row) => row.id_pallet);

    //         totalSheetsAndReam(newSelectedRows);
    //         setSelectedRows(newSelectedRows);
    //         return;
    //     }
    //     setSelectedRows([]);
    // };


    const selectableRows = reelList.filter(row => row.status !== 'converted');
    const allSelected = selectedRows.length === selectableRows.length && selectableRows.length > 0;
    const someSelected = selectedRows.length > 0 && selectedRows.length < selectableRows.length;

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            // Select all selectable rows (exclude 'converted')
            const newSelectedRows = selectableRows.map(row => row.id_pallet);
            totalSheetsAndReam(newSelectedRows);
            setSelectedRows(newSelectedRows);
            return;
        }
        // Clear selection on uncheck
        setSelectedRows([]);
    };



    const handleRowCheckboxClick = (event, rowId) => {
        const selectedIndex = selectedRows.indexOf(rowId);
        let newSelectedRows = [];

        if (selectedIndex === -1) {
            newSelectedRows = [...selectedRows, rowId];
        } else if (selectedIndex === 0) {
            newSelectedRows = selectedRows.slice(1);
        } else if (selectedIndex === selectedRows.length - 1) {
            newSelectedRows = selectedRows.slice(0, -1);
        } else if (selectedIndex > 0) {
            newSelectedRows = [
                ...selectedRows.slice(0, selectedIndex),
                ...selectedRows.slice(selectedIndex + 1),
            ];
        }

        totalSheetsAndReam(newSelectedRows);
        setSelectedRows(newSelectedRows);

    };

    const handleRowClick = (event, id, status) => {
        if (status === 'converted') return;
        handleRowCheckboxClick(event, id);
    };

    const totalSheetsAndReam = (newSelectedRows) => {
        let selectedLines = [];
        if (jobID === 0) {
            selectedLines = reelList.filter((f) => newSelectedRows.includes(f.id_pallet));
        }
        else {
            selectedLines = newSelectedRows;
        }
        // let selectedLines = reelList.filter((f) => newSelectedRows.includes(f.id_pallet));
        let totalSheets = selectedLines.reduce((acc, item) => acc + item.number_of_sheets, 0);
        let totalPalletWeight = selectedLines.reduce((acc, item) => acc + item.pallet_weight, 0);
        let totalReams = parseInt(totalSheets / sheeterNoOfSheets);
        let lReams = 0;

        setPalletWeight(totalPalletWeight);

        if (totalSheets > (totalReams * sheeterNoOfSheets)) {
            setlossReams(1);
            lReams = 1;
            // lose ream-weight
            let balancesheets = totalSheets - (totalReams * sheeterNoOfSheets);
            let LReamwt = (totalPalletWeight / totalSheets) * balancesheets; //(palletWeight - (ReamWeight * numberofReams));


            LReamwt = Math.round(LReamwt * GlobalConfig.DecimalPointsReamWeight) / GlobalConfig.DecimalPointsReamWeight;


            setLReamWeight(LReamwt);
            setBalanceSheet(balancesheets);
        }
        else {
            setlossReams(0);
            setLReamWeight(0);
            setBalanceSheet(0);
            lReams = 0;
        }

        // ream-weight

        //let ReamWeight = (totalPalletWeight / totalSheets) * sheeterNoOfSheets;

        let ReamWeight = ReamWeightCalcualtion(sheeterNoOfSheets);


        setReamWeight(ReamWeight);

        setTotalReams(totalReams + lReams);
        setNumberOfReams(totalReams);
        setNumberOfSheets(totalSheets);

    };


    useEffect(() => {
        if (sheeterNoOfSheets > 0 && numberofSheets > 0) {

            // total ream calculation
            let totalReams = parseInt(numberofSheets / sheeterNoOfSheets);
            setNumberOfReams(totalReams);
            let lReams = 0;

            // ream weight calculation
            let ReamWeight = (palletWeight / numberofSheets) * sheeterNoOfSheets;


            ReamWeight = ReamWeightCalcualtion(sheeterNoOfSheets);


            setReamWeight(ReamWeight);

            if (numberofSheets > (totalReams * sheeterNoOfSheets)) {
                // setlossReams(1);
                // lReams = 1;
                // // lose ream-weight
                // let balancesheets = numberofSheets - (totalReams * sheeterNoOfSheets);
                // let LReamwt = (palletWeight / numberofSheets) * balancesheets; //(palletWeight - (ReamWeight * numberofReams));
                // LReamwt = parseFloat(LReamwt.toFixed(2));
                // setLReamWeight(LReamwt);
                // setBalanceSheet(balancesheets);
            }
            else {
                setlossReams(0);
                setLReamWeight(0);
                setBalanceSheet(0);
                lReams = 1;
            }

            setTotalReams(totalReams + lReams);
        }
        else {
            setTotalReams(0);
        }

    }, [sheeterNoOfSheets, setSheeterNoOfSheets, numberofSheets, setNumberOfSheets]);

    const isSelected = (rowId) => selectedRows.indexOf(rowId) !== -1;



    // pallet list
    const handleSelectAllClickPallet = (event) => {
        if (event.target.checked) {
            const newSelectedRows = reamList.map((row) => row.ream_id);
            setSelectedReamRows(newSelectedRows);
            return;
        }
        setSelectedReamRows([]);
    };

    const handleRowCheckboxClickPallet = (event, rowId) => {
        const selectedIndex = selectedReamRows.indexOf(rowId);
        let newSelectedRows = [];

        if (selectedIndex === -1) {
            newSelectedRows = [...selectedReamRows, rowId];
        } else if (selectedIndex === 0) {
            newSelectedRows = selectedReamRows.slice(1);
        } else if (selectedIndex === selectedReamRows.length - 1) {
            newSelectedRows = selectedReamRows.slice(0, -1);
        } else if (selectedIndex > 0) {
            newSelectedRows = [
                ...selectedReamRows.slice(0, selectedIndex),
                ...selectedReamRows.slice(selectedIndex + 1),
            ];
        }

        setSelectedReamRows(newSelectedRows);

    };

    const isSelectedReam = (rowId) => selectedReamRows.indexOf(rowId) !== -1;

    const [selectedChip, setSelectedChip] = useState('Combinations');


    const handleChipClick = (chipName) => {
        setSelectedChip(chipName);

        if (chipName === 'View Reel List') {
            setViewLineItemList(false);
            setviewPalletList(true);
            setviewReamProcess(false);
        }
        else if (chipName === 'View Sheeter Process') {
            setviewSheeterchildRollDetail(true);
            setviewPalletList(false);
        }
        else if (chipName === 'Line Item Wise Achieved Reels') {
            setViewLineItemList(true);
            setviewPalletList(false);
        }
        else if (chipName === 'View Summary') {
            // setviewSheeterchildRollDetail(true);
            setViewJob(true);
            setNewJob(false);
            setJobID(0);
        }


        // setShowFunction();
    };
    const iconStyle = {
        fontSize: '24px', // Ensure all icons have the same size
    };

    const selectedChipStyle = {
        borderColor: colors.greenAccent[200],
        borderWidth: '0.5px',
        borderStyle: 'solid',
        backgroundColor: colors.primary[700],
        // borderColor: '#2196F3',
        color: 'white'
    };

    const unselectedChipStyle = {

        borderColor: 'transparent',
        borderWidth: '1px',
        borderStyle: 'solid',
        backgroundColor: colors.primary[400],
        color: 'white',
    };

    const createUniqueRollArray = (data) => {
        const seenRolls = new Set(); // To track unique cr_numbers
        const result = [];

        data.forEach((item) => {
            const rolls = item.cr_number.split(", ").map((roll) => roll.trim()); // Split and trim the rolls
            rolls.forEach((roll) => {
                if (!seenRolls.has(roll)) {
                    seenRolls.add(roll); // Add to seenRolls to avoid duplicates
                    result.push({ id_reel: roll, code: roll });
                }
            });
        });

        return result;
    };


    const LoadSelectedLineItemList = () => {

        setSelectedChip('View Sheeter Process');
        const selectedReels = reelList.filter((reels) => selectedRows.includes(reels.id_pallet));
        if (selectedReels.length > 0) {
            setSelectedReelList(selectedReels);
            setviewReamProcess(true);
            setviewPalletList(false);

            const newArray = createUniqueRollArray(selectedReels);
            setSelectedUniqueReelList(newArray);

        }

    }
    // Get Shift Codes
    useEffect(() => {
        if (!isDataLoaded) {
            const para = {
                p_companyid: localStorage.getItem('companyid'),
            }

            callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_SHIFT_CODE, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setShiftCodes(data);
                        setWinderShiftCode(data[0]);
                        setWinderShiftID(data[0].shiftid);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });

        }
    }, [isDataLoaded]);

    const handleWinderShiftChange = (event, value) => {
        setWinderShiftCode(value);
        setWinderShiftID(value.shiftid);
    }



    useEffect(() => {
        if (!isOperatorDataLoaded) {
            const para = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
            }
            callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_OPERATOR, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setOperator(data);
                        setSelectedOperator(data[0]);
                        setSelectedOperatorName(data[0].operator_code);
                        setWinderOperators(data[0].operator_code);
                        setOperatorID(data[0].id);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });
        }
    }, [isOperatorDataLoaded]);


    const handleOperatorChange = (event, value) => {
        setSelectedOperator(value);
        setSelectedOperatorName(value.operator_code);
        setWinderOperators(value.operator_code);
        setOperatorID(value.id);
    }


    const viewQRCode = async () => {
        const palletDetails1 = approvedPalletNumber.filter((ream) => selectedReamRows.includes(ream.id));
        const palletDetails = reamList.filter((ream) => selectedReamRows.includes(ream.ream_id));
        setSelectedReamDetails(palletDetails);
        setSelectedReamDetailsQR(palletDetails1);
        setViewReamQRCode(true);
    };

    const handlecallEditJob = (jobID) => {
        if (!hasPermission(userPermissions, "Ream Punching", "View")) {
            alert("Access denied. You don’t have permission to view this page.");
            return; // Exit the function if permission is not granted
        }

        setJobID(jobID);

        setviewReamProcess(true);
        setviewPalletList(false);
        setViewLineItemList(false);

        setSelectedChip('View Sheeter Process');
        setViewJob(false);
        setNewJob(true);
    }

    // get job header details
    const [jobHDRDetails, setJobHDRDetails] = useState([]);
    const [updateshiftCode, setUpdateShiftCode] = useState('');
    const [updateOperator, setUpdateOperator] = useState('');
    const [shiftCodeUpdate, setShiftCodeUpdate] = useState(false);
    const [operatorUpdate, setOperatorUpdate] = useState(false);

    useEffect(() => {
        if (jobID > 0) {



            const orderData = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
                p_job_number: jobID

            };
            callApi(API_ENDPOINTS.PROD_MANAGEMENT_REAM_CONVERTION_GET_JOD_HDR_DETAIL_USING_JOB_ID, 'POST', { 'Content-Type': 'application/json' }, orderData)
                .then(data => {
                    if (data && data.length > 0) {
                        const [firstJob] = data;
                        setJobHDRDetails(data);
                        setSheeterNoOfSheets(data[0].no_of_sheets);
                        //calculatePallets(data[0].no_of_sheets);

                        setUpdateShiftCode(firstJob.shift_code);
                        setShiftCodeUpdate(false);
                        setUpdateOperator(firstJob.s_operator);
                        setFNo(firstJob.fno);
                        setOperatorUpdate(false);

                        setShiftDate(dayjs(firstJob.shift_date));

                    } else {
                        // No data found
                        setJobHDRDetails([]);
                        callError('info', 'No data found, Kindly adjust data range.', 'info');
                    }
                })
                .catch(error => { callError('error', error.message, 'Error'); });
        }

    }, [jobID]);


    useEffect(() => {
        if (jobID > 0) {

            const orderData = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
                p_job_number: jobID

            };
            callApi(API_ENDPOINTS.PROD_MANAGEMENT_REAM_CONVERTION_GET_ORDER_LINE_ITEMS_WISE_PALLET_LIST_USING_JOB_ID, 'POST', { 'Content-Type': 'application/json' }, orderData)
                .then(data => {
                    if (data && data.length > 0) {
                        setSelectedReelList(data);
                        totalSheetsAndReam(data);

                        const parameter = {
                            p_companyid: localStorage.getItem('companyid'),
                            p_plantid: 1,
                            p_indent_no: data[0].indent_no,
                            p_lineno: data[0].line_no

                        };

                        callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_SELECTED_ORDER_LINE_ITEMS_DETAILS, 'POST', { 'Content-Type': 'application/json' }, parameter)
                            .then(LineItemData => {
                                if (LineItemData && LineItemData.length > 0) {
                                    setSelectedLineItemDetail(LineItemData);

                                    setGSM(LineItemData[0].gsm);
                                    setWidth(LineItemData[0].d_length);
                                    setLength(LineItemData[0].d_width);

                                    callApi(API_ENDPOINTS.PROD_MANAGEMENT_REAM_Get_produced_sheets_based_on_reams_job_number, 'POST', { 'Content-Type': 'application/json' }, orderData)
                                        .then(LineItemData => {
                                            if (LineItemData && LineItemData.length > 0) {
                                                setNumberOfSheets(LineItemData[0].number_of_sheets);
                                            }
                                        })
                                        .catch(error => { callError('error', error.message, 'Error'); });
                                }
                            })
                            .catch(error => { callError('error', error.message, 'Error'); });

                    } else {

                        // No data found
                        setSelectedReelList([]);
                        callError('info', 'No data found, Kindly adjust data range.', 'info');
                    }
                })
                .catch(error => { callError('error', error.message, 'Error'); });
        }

    }, [jobID]);


    // reel list
    useEffect(() => {
        if (jobID > 0) {

            const orderData = {
                p_companyid: localStorage.getItem('companyid'),
                p_ream_number: '',
                p_mode: 1,
                p_pallet_id: jobID
            };

            callApi(API_ENDPOINTS.PROD_MANAGEMENT_SEARCH_GET_REAM_DETAIL, 'POST', { 'Content-Type': 'application/json' }, orderData)
                .then(data => {
                    if (data && data.length > 0) {

                        // Assuming `pallets` is your API response array
                        const formattedPallets = data.map((item) => ({
                            ...item,
                            shift_date: dayjs(item.shift_date).format('DD-MMM-YYYY'), // Format the date
                        }));

                        // Set the formatted array to the state
                        setReamList(formattedPallets);
                        setViewReamQRCode(true);


                        // Group by `cr_number` and count occurrences
                        const counts = data.reduce((acc, row) => {
                            acc[row.cr_number] = (acc[row.cr_number] || 0) + 1;
                            return acc;
                        }, {});

                        // Convert to array format
                        const result = Object.entries(counts).map(([id_reel, sheetCount, repulp_qty, grade, winder_remarks]) => ({
                            id_reel,
                            sheetCount,
                            repulp_qty,
                            grade,
                            winder_remarks
                        }));




                        setSheetCounts(result);

                        // const uniqueCrNumbers = Array.from(new Set(data.map(item => item.cr_number)));

                        const uniqueCrNumbers = Array.from(
                            data.reduce((map, item) => {
                                if (!map.has(item.cr_number)) {
                                    map.set(item.cr_number, {
                                        cr_number: item.cr_number,
                                        repulp_qty: item.repulp_qty,
                                        grade: item.grade,
                                        winder_remarks: item.winder_remarks,
                                    });
                                }
                                return map;
                            }, new Map()).values()
                        );
                        // const result1 = uniqueCrNumbers.map(cr_number => ({
                        //     id_reel: cr_number,
                        //     code: cr_number
                        // }));

                        const result1 = uniqueCrNumbers.map(item => ({
                            id_reel: item.cr_number,
                            code: item.cr_number,
                            repulp_qty: item.repulp_qty,
                            grade: item.grade,
                            winder_remarks: item.winder_remarks
                        }));
                        setSelectedUniqueReelList(result1);

                        setNumberOfReams(data.length);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });

        }
    }, [jobID]);


    const GetProducedReamList = () => {
        if (jobID > 0) {

            const orderData = {
                p_companyid: localStorage.getItem('companyid'),
                p_ream_number: '',
                p_mode: 1,
                p_pallet_id: jobID
            };

            callApi(API_ENDPOINTS.PROD_MANAGEMENT_SEARCH_GET_REAM_DETAIL, 'POST', { 'Content-Type': 'application/json' }, orderData)
                .then(data => {
                    if (data && data.length > 0) {

                        // Assuming `pallets` is your API response array
                        const formattedPallets = data.map((item) => ({
                            ...item,
                            shift_date: dayjs(item.shift_date).format('DD-MMM-YYYY'), // Format the date
                        }));

                        // Set the formatted array to the state
                        setReamList(formattedPallets);
                        setViewReamQRCode(true);



                        console.log(data);


                        // Group by `cr_number` and count occurrences
                        const counts = data.reduce((acc, row) => {
                            acc[row.cr_number] = (acc[row.cr_number] || 0) + 1;
                            return acc;
                        }, {});

                        // Convert to array format
                        const result = Object.entries(counts).map(([id_reel, sheetCount, repulp_qty, grade, winder_remarks]) => ({
                            id_reel,
                            sheetCount,
                            repulp_qty,
                            grade,
                            winder_remarks
                        }));



                        console.log(result);
                        setSheetCounts(result);

                        // const uniqueCrNumbers = Array.from(new Set(data.map(item => item.cr_number)));

                        // const result1 = uniqueCrNumbers.map(cr_number => ({
                        //     id_reel: cr_number,
                        //     code: cr_number
                        // }));

                        const uniqueCrNumbers = Array.from(
                            data.reduce((map, item) => {
                                if (!map.has(item.cr_number)) {
                                    map.set(item.cr_number, {
                                        cr_number: item.cr_number,
                                        repulp_qty: item.repulp_qty,
                                        grade: item.grade,
                                        winder_remarks: item.winder_remarks,
                                    });
                                }
                                return map;
                            }, new Map()).values()
                        );
                        // const result1 = uniqueCrNumbers.map(cr_number => ({
                        //     id_reel: cr_number,
                        //     code: cr_number
                        // }));

                        const result1 = uniqueCrNumbers.map(item => ({
                            id_reel: item.cr_number,
                            code: item.cr_number,
                            repulp_qty: item.repulp_qty,
                            grade: item.grade,
                            winder_remarks: item.winder_remarks
                        }));
                        setSelectedUniqueReelList(result1);

                        setNumberOfReams(data.length);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });

        }
    }



    useEffect(() => {
        if (shiftCodeUpdate) return;

        const params = { p_companyid: localStorage.getItem('companyid') };

        callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_SHIFT_CODE, 'POST', { 'Content-Type': 'application/json' }, params)
            .then(data => {
                if (data?.length) {
                    setShiftCodes(data);
                    const selectedShift = data.find(shift => shift.shiftid === updateshiftCode);
                    if (selectedShift) {
                        setWinderShiftCode(selectedShift);
                        setWinderShiftID(selectedShift.shiftid);
                    }
                }
                setShiftCodeUpdate(true);
            })
            .catch(error => alert(error.message));
    }, [updateshiftCode, shiftCodeUpdate]);

    useEffect(() => {
        if (operatorUpdate) return;

        const params = { p_companyid: localStorage.getItem('companyid'), p_plantid: 1 };

        callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_OPERATOR, 'POST', { 'Content-Type': 'application/json' }, params)
            .then(data => {
                if (data?.length) {
                    setOperator(data);
                    const selectedOperator = data.find(operator => operator.operator_code === updateOperator);
                    if (selectedOperator) {
                        setSelectedOperator(selectedOperator);
                        setSelectedOperatorName(selectedOperator.operator_code);
                        setWinderOperators(selectedOperator.operator_code);
                    }
                }
                setOperatorUpdate(true);
            })
            .catch(error => alert(error.message));
    }, [updateOperator, operatorUpdate]);


    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleFilterChange = (event) => {
        const { name, value } = event.target;
        setFilters({ ...filters, [name]: value });
    };

    const convertInputDate = (dateString) => {
        const [year, month, day] = dateString.split('-');
        return `${month}/${day}/${year}`;
    };

    const convertDataDate = (dateString) => {
        const [day, month, year] = dateString.split('/');
        return `${month}/${day}/${year}`;
    };

    const summaryData = summaryList.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied

                if (key === 'from_date' || key === 'to_date') {
                    // Convert row date to Date object
                    const rowDate = new Date(convertDataDate(row.date));
                    const fromDate = filters.from_date ? new Date(convertInputDate(filters.from_date)) : null;
                    const toDate = filters.to_date ? new Date(convertInputDate(filters.to_date)) : null;

                    // Check if row date is within the range
                    if (fromDate && toDate) {
                        return rowDate >= fromDate && rowDate <= toDate;
                    } else if (fromDate) {
                        return rowDate >= fromDate;
                    } else if (toDate) {
                        return rowDate <= toDate;
                    }
                    return true;
                }

                // Default string comparison for other filters
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });

    const applyFilter = () => {

        const convertInputDate = (dateString) => {
            const [year, month, day] = dateString.split('-');
            return `${month}/${day}/${year}`;
        };

        // Convert 'dd/mm/yyyy' to 'mm/dd/yyyy'
        const convertDataDate = (dateString) => {
            const [day, month, year] = dateString.split('/');
            return `${month}/${day}/${year}`;
        };

        const fromDate = new Date(convertInputDate(filters.from_date));
        const toDate = new Date(convertInputDate(filters.to_date));

        const summaryData = summaryList.filter(item => {
            const itemDate = new Date(convertDataDate(item.date));
            return itemDate >= fromDate && itemDate <= toDate;
        });

        console.log(summaryData); // Use `filteredData` as needed
        //setFilteredData(filteredData);
    };

    // sorting process
    const [sortDirection, setSortDirection] = useState('asc');
    const [sortColumn, setSortColumn] = useState('date'); // Default sort by 'date'


    const handleSort = (column) => {
        const newDirection = sortColumn === column && sortDirection === 'asc' ? 'desc' : 'asc';
        setSortDirection(newDirection);
        setSortColumn(column);
    };

    const sortedData = useMemo(() => {
        return [...summaryData].sort((a, b) => {
            if (a[sortColumn] < b[sortColumn]) return sortDirection === 'asc' ? -1 : 1;
            if (a[sortColumn] > b[sortColumn]) return sortDirection === 'asc' ? 1 : -1;
            return 0;
        });
    }, [summaryData, sortColumn, sortDirection]);

    const handleSubMenuButtonClick = (buttonName) => {
        setSelectedButton(buttonName);
        // setSelectedButtonName(buttonName);

        // handlecallProcess(buttonName);
        setSelectedChip(buttonName);

        if (buttonName === 'View Reel List') {
            setViewLineItemList(false);
            setviewPalletList(true);
            setviewReamProcess(false);
            setViewReamQRCode(false); //new added for hide produced ream list
            setSheeterMsgOpen(false);

            if (disableSaveBtn) {
                if (selectedOrderItems) {
                    handleCallEdit(selectedOrderItems);
                    setSelectedRows([]);
                    setDisableSaveBtn(false);

                    // const updatedSheetCounts = sheetCounts.map((item) => ({
                    //     ...item,
                    //     sheetCount: 0, // Reset sheetCount to 0
                    // }));
                    setSheetCounts([]); // Update the state
                    setSelectedUniqueReelList([]);
                    setNumberOfReams(0);

                    setShiftDate(dayjs());


                }
            }


        }
        else if (buttonName === 'View Sheeter Process') {
            setviewSheeterchildRollDetail(true);
            setviewPalletList(false);
        }
        else if (buttonName === 'Line Item Wise Achieved Reels') {
            setViewLineItemList(true);
            setviewPalletList(false);
        }
        else if (buttonName === 'View Summary') {
            // setviewSheeterchildRollDetail(true);
            setViewJob(true);
            setNewJob(false);
            setJobID(0);
            LoadJobList();
        }
    };
    const [sheetCounts, setSheetCounts] = useState([]);
    const handleInputChange = (id_reel, value) => {
        const numericValue = parseInt(value, 10) || 0;

        setSheetCounts((prev) => {
            // If `sheetCounts` is empty, add the new value directly
            if (prev.length === 0) {

                setNumberOfReams(numericValue);
                setlossReams(0);
                setLReamWeight(0);

                return [{ id_reel, sheetCount: numericValue }];
            }

            // Calculate the total from the existing values
            const totalSheets = prev.reduce(
                (total, item) => total + (parseInt(item.sheetCount, 10) || 0),
                0
            );

            // Update or add the new entry
            const updatedCounts = prev.filter((item) => item.id_reel !== id_reel);
            updatedCounts.push({ id_reel, sheetCount: numericValue });

            // Update the total with the new value
            const newTotal =
                totalSheets +
                numericValue -
                (prev.find((item) => item.id_reel === id_reel)?.sheetCount || 0);
            setNumberOfReams(newTotal);


            setlossReams(0);
            setLReamWeight(0);

            return updatedCounts;
        });
    };

    // // {viewLineItemList && (
    // if (loading && viewLineItemList) {
    //     return (
    //         <Box
    //         sx={{
    //             display: 'flex',
    //             justifyContent: 'center',
    //             alignItems: 'center',
    //             height: '100px', // Adjust the height as needed
    //             marginTop: '50px',
    //         }}
    //     >
    //         <CircularProgress
    //             size={40} // Adjust size of the CircularProgress
    //             thickness={4} // Adjust thickness of the CircularProgress
    //             sx={{
    //                 color: '#4CAF50', // Set the desired color
    //             }}
    //         />
    //     </Box>
    //     );
    //   }


    const handleFromShiftDateChange = (date) => {
        setFromShiftDate(dayjs(date));
    };

    const handleToShiftDateChange = (date) => {
        setToShiftDate(dayjs(date));
    };

    // filter oprations 
    const columns = ['job_number', 'shift_code', 'shift_date', 'indent_no', 'cr_number', 's_operator', 'plt_number', 'ream_count', 'status'];
    const autoCompleteColumns = ['job_number', 'shift_code', 'shift_date', 'indent_no', 'cr_number', 's_operator', 'plt_number', 'ream_count', 'status'];

    const handleFilterChangeTable = (e, column) => {
        setFilters({ ...filters, [column]: e.target.value });
    };

    const uniqueValues = {
        job_number: [...new Set(summaryList.map(row => row.job_number))],
        shift_code: [...new Set(summaryList.map(row => row.shift_code))],
        shift_date: [...new Set(summaryList.map(row => row.shift_date))],
        indent_no: [...new Set(summaryList.map(row => row.indent_no))],
        cr_number: [...new Set(summaryList.map(row => row.cr_number))],
        s_operator: [...new Set(summaryList.map(row => row.s_operator))],
        plt_number: [...new Set(summaryList.map(row => row.plt_number))],
        status: [...new Set(summaryList.map(row => row.status))],

    };

    return (
        <Box>

            <Dialog
                open={openWIPListModal}
                onClose={handleCloseWIPListModal}
                fullWidth
                maxWidth="xl"
            >
                {/* <DialogTitle sx={{ m: 0, p: 1.5 }}>
                    <Typography variant="h6"> WIP Pallet Details</Typography>
                    <IconButton
                      onClick={handleCloseWIPListModal}
                      sx={{ position: "absolute", right: 8, top: 8 }}
                    >
                      <Close />
                    </IconButton>
                  </DialogTitle> */}
                <DialogContent>
                    {/* Correctly pass the prop inside the component tag */}
                    <ReportReamPunchingWIPReamList
                        handleBackSheeterMachineEntry={handleBackSheeterMachineEntry}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseWIPListModal} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            {viewJob && (
                <>
                    <Divider />
                    <AppBar position="static" sx={{ backgroundColor: "inherit", borderRadius: "0px", height: "48px", justifyContent: "center" }}>
                        <Toolbar>
                            {/* First Menu */}
                            <Button
                                color="secondary"
                                onClick={handleMenuClickFirst}
                                endIcon={<ExpandMoreIcon sx={{ color: "teal", fontSize: "18px" }} />}
                                sx={{ textTransform: 'none', fontSize: "16px", fontWeight: "500" }}
                            >
                                {selectedOptionFirst}
                            </Button>
                            <Menu
                                anchorEl={anchorElFirst}
                                open={openFirst}
                                onClose={handleMenuCloseFirst}

                            >
                                <MenuItem onClick={() => handleMenuItemClickFirst('All Child Roll List')}>Ream Puching Summary</MenuItem>
                            </Menu>

                            {/* Adding margin-left: auto to push the button to the right */}
                            <Box display="flex" justifyContent="flex-end" gap={1} width="100%">
                                <Button
                                    size="small"
                                    variant="contained"
                                    onClick={handleOpenWIPListModal}
                                    color="secondary"
                                    sx={{ textTransform: 'none' }}
                                >
                                    View WIP Ream List
                                </Button>

                                <Button
                                    size="small"
                                    variant="contained"
                                    onClick={handleShowNewVendor}
                                    color="secondary"
                                    startIcon={<AddIcon sx={{ fontSize: "18px" }} />}
                                    sx={{ textTransform: 'none' }}
                                >
                                    New
                                </Button>
                            </Box>



                            {/* <Button
    size="small"
    variant="contained"
    onClick={handleOpenWIPListModal}
    color="secondary"
    sx={{ marginLeft: 'left', textTransform: 'none' }}
  >
    View WIP Ream List
  </Button>

                            <Button size="small" variant="contained" onClick={handleShowNewVendor} color="secondary" startIcon={<AddIcon sx={{ fontSize: "18px" }} />} sx={{ marginLeft: 'auto', textTransform: 'none' }}>New</Button> */}

                            {/* <Box display="flex" justifyContent="flex-end" gap={1}> */}
                            {/* <Button
    size="small"
    variant="contained"
    onClick={handleOpenWIPListModal}
    color="secondary"
    sx={{ textTransform: 'none' }}
  >
    View WIP Ream List
  </Button> */}

                            {/* <Button
    size="small"
    variant="contained"
    onClick={handleShowNewVendor}
    color="secondary"
    startIcon={<AddIcon sx={{ fontSize: "18px" }} />}
    sx={{ textTransform: 'none' }}
  >
    New
  </Button> */}
                            {/* </Box> */}


                            {/* Second Menu */}
                            <IconButton
                                size="small"
                                // edge="start"
                                // color="inherit"
                                aria-label="menu"
                                sx={{ ml: 2 }}
                                onClick={handleMenuClickSecond}
                            >
                                <MoreVertIcon sx={{ fontSize: "18px" }} />
                            </IconButton>
                            <Menu
                                anchorEl={anchorElSecond}
                                open={openSecond}
                                onClose={handleMenuCloseSecond}
                            >
                                <MenuItem onClick={() => handleMenuItemClickSecond('Import Vendors')}>
                                    <ListItemIcon>
                                        <ImportExportIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Import Child rolls" />
                                </MenuItem>
                                <MenuItem onClick={() => handleMenuItemClickSecond('Export Vendors')}>
                                    <ListItemIcon>
                                        <FileDownloadIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Export Child rolls" />
                                </MenuItem>
                                <Divider />
                                <MenuItem onClick={() => handleMenuItemClickSecond('Export Current View')}>
                                    <ListItemIcon>
                                        <ViewColumnIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Export Current View" />
                                </MenuItem>
                                <Divider />
                                <MenuItem onClick={() => handleMenuItemClickSecond('Preference List')}>
                                    <ListItemIcon>
                                        <ListAltIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Preference " />
                                </MenuItem>
                                <Divider />
                                <MenuItem onClick={() => handleMenuItemClickSecond('Refresh List')}>
                                    <ListItemIcon>
                                        <RefreshIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Refresh List" />
                                </MenuItem>
                                <Divider />
                                <MenuItem onClick={() => handleMenuItemClickSecond('Reset Column Width')}>

                                    <Button variant="contained" color="secondary" size="small" startIcon={<FormatAlignJustifyIcon />}>
                                        Reset Columns Width
                                    </Button>
                                </MenuItem>
                            </Menu>



                            <div>
                                <IconButton onClick={handleBackWinderMachineEntry} >
                                    <Close sx={{ fontSize: "18px", color: "#2196F3" }} />
                                </IconButton>
                            </div>
                        </Toolbar>
                    </AppBar>

                    <Grid container padding="5px 0px 5px 5px" alignItems="center" sx={{ mt: 0, mb: 0, pt: 0, pb: 0, justifyContent: "flex-end" }} >
                        <Grid item xs={2} sm={3} md={1.5} lg={1.5} xl={1} mt="5px">
                            <FormControl fullWidth size="small">
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        style={{ marginLeft: '10px' }}
                                        id="FromDate"
                                        value={dayjs(FromShiftDate)}
                                        onChange={(date) => handleFromShiftDateChange(date)}

                                        slotProps={{
                                            textField: {
                                                size: 'small',
                                                variant: 'standard', // Removes the filled/outlined border
                                                InputProps: {
                                                    disableUnderline: true, // Remove underline from 'standard' variant
                                                },
                                                sx: {
                                                    backgroundColor: 'transparent',
                                                    padding: 0,
                                                    '& .MuiInputBase-root': {
                                                        border: 'none',
                                                    },
                                                    '& .MuiSvgIcon-root': {
                                                        fontSize: '18px', // 👈 smaller icon size
                                                    },
                                                    '& .MuiInputBase-root': {
                                                        paddingRight: '6px', // optional: reduce padding around icon
                                                    },
                                                },
                                            }
                                        }}
                                        renderInput={(props) => <TextField {...props} />}
                                        autoFocus
                                        format="DD-MMM-YYYY"
                                    />
                                </LocalizationProvider>
                            </FormControl>
                        </Grid>
                        <Grid item mt="5px" ml="10px" mr="10px">
                            <Typography fontWeight="bold">-</Typography>
                        </Grid>


                        <Grid item xs={2} sm={3} md={1.5} lg={1.5} xl={1} mt="5px" mr="10px">
                            <FormControl fullWidth size="small" >
                                <LocalizationProvider dateAdapter={AdapterDayjs} style={{ marginLeft: '10px' }}>
                                    <DatePicker
                                        id="ToDate"
                                        value={dayjs(ToShiftDate)}
                                        format="DD-MMM-YYYY"
                                        onChange={(date) => handleToShiftDateChange(date)}

                                        slotProps={{
                                            textField: {
                                                size: 'small',
                                                variant: 'standard', // Removes the filled/outlined border
                                                InputProps: {
                                                    disableUnderline: true, // Remove underline from 'standard' variant
                                                },
                                                sx: {
                                                    backgroundColor: 'transparent',
                                                    padding: 0,
                                                    '& .MuiInputBase-root': {
                                                        border: 'none',
                                                    },
                                                    '& .MuiSvgIcon-root': {
                                                        fontSize: '18px', // 👈 smaller icon size
                                                    },
                                                    '& .MuiInputBase-root': {
                                                        paddingRight: '6px', // optional: reduce padding around icon
                                                    },
                                                },
                                            }
                                        }}
                                        renderInput={(props) => <TextField {...props} />}
                                    />
                                </LocalizationProvider>
                            </FormControl>
                        </Grid>


                    </Grid>

                    <Divider sx={{ marginTop: "5px" }} />
                    <ResponsiveBox colors={colors} customMaxHeight={{
                        xs: '72vh', // Extra small devices (phones)
                        sm: '72vh', // Small devices (tablets)
                        md: '74vh', // Medium devices (small laptops)
                        lg: '82vh', // Large devices (desktops)
                        xl: '86vh', // Extra large devices (large desktops)
                    }}>
                        <CustomTableContainer colors={colors} >
                            <TableContainer >
                                {loading ? (
                                    <SkeletonTableLoader rows={5} columns={11} />
                                ) : (
                                    <Table size="small">
                                        <TableHead sx={{ backgroundColor: colors.primary[400] }}>
                                            <TableRow>
                                                <TableCell onClick={() => handleSort('job_number')}>
                                                    JOB NUMBER {sortColumn === 'job_number' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                </TableCell>
                                                <TableCell onClick={() => handleSort('shift_code')}>
                                                    SHIFT {sortColumn === 'shift_code' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                </TableCell>
                                                <TableCell onClick={() => handleSort('shift_date')}>
                                                    SHIFT DATE {sortColumn === 'shift_date' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                </TableCell>
                                                <TableCell onClick={() => handleSort('indent_no')}>
                                                    CO NUMBER {sortColumn === 'indent_no' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                </TableCell>
                                                <TableCell onClick={() => handleSort('cr_number')}>
                                                    CR NUMBER {sortColumn === 'cr_number' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                </TableCell>



                                                <TableCell onClick={() => handleSort('s_operator')}>
                                                    SUPERVISOR {sortColumn === 's_operator' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                </TableCell>
                                                <TableCell onClick={() => handleSort('cr_number')}>
                                                    PALLET NUMBER {sortColumn === 'cr_number' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                </TableCell>
                                                <TableCell onClick={() => handleSort('pallet_count')}>
                                                    NO.OF.SHEET IN REAM  {sortColumn === 'pallet_count' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                </TableCell>

                                                <TableCell onClick={() => handleSort('status')}>
                                                    STATUS {sortColumn === 'status' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                </TableCell>

                                                <TableCell>
                                                    <IconButton onClick={handleOpen}>
                                                        <Searchicon style={{ fontSize: "16px" }} />
                                                    </IconButton>
                                                    <Modal
                                                        open={open}
                                                        onClose={handleClose}
                                                        aria-labelledby="modal-modal-title"
                                                        aria-describedby="modal-modal-description"
                                                    >
                                                        <Box sx={{ position: 'absolute', top: '38.2%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: colors.primary[400], boxShadow: 29, p: 4, minWidth: 300 }}>

                                                            <TextField
                                                                label="CO Number"
                                                                name="indent_no"
                                                                value={filters.indent_no}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                            />

                                                            <TextField
                                                                label="Child Reel Number"
                                                                name="cr_number"
                                                                value={filters.cr_number}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                            />

                                                            <TextField
                                                                label="Shift Code"
                                                                name="shift_code"
                                                                value={filters.shift_code}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                            />

                                                            <TextField
                                                                label="Pallet Number"
                                                                name="plt_number"
                                                                value={filters.plt_number}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                            />


                                                            <Button variant="contained" color="secondary" onClick={() => { applyFilter(); handleClose(); }} style={{ marginTop: 10 }}>
                                                                Apply Filter
                                                            </Button>
                                                        </Box>
                                                    </Modal>
                                                </TableCell>
                                            </TableRow>
                                            <TableFilterRow
                                                columns={columns}
                                                filters={filters}
                                                handleFilterChange={handleFilterChangeTable}
                                                uniqueValues={uniqueValues}
                                                autoCompleteColumns={autoCompleteColumns}
                                            />
                                        </TableHead>
                                        <TableBody>
                                            {sortedData.map((row, index) => (
                                                <TableRow key={row.id} sx={{ backgroundColor: index % 2 === 0 ? theme.palette.background.default : alpha(theme.palette.action.hover, 0.04), }}>
                                                    <TableCell> <span
                                                        style={{ minWidth: 100, whiteSpace: "nowrap", color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                                                        onClick={() => handlecallEditJob(row.job_number)}
                                                    >
                                                        JOB# {row.job_number}
                                                    </span></TableCell>
                                                    <TableCell>{row.shift_code}</TableCell>
                                                    <TableCell style={{ minWidth: 100, whiteSpace: "nowrap" }}>{row.shift_date}</TableCell>
                                                    <TableCell style={{ minWidth: 100, whiteSpace: "nowrap" }}>{row.indent_no}</TableCell>
                                                    <TableCell >{row.cr_number}</TableCell>
                                                    <TableCell>{row.s_operator}</TableCell>
                                                    <TableCell sx={{ width: '100px' }}>
                                                        {/* <span
                                                    style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                                                    onClick={() => handlecallEditJob(row.id, row.cr_number)}
                                                > */}
                                                        {row.plt_number}
                                                        {/* </span> */}
                                                    </TableCell>
                                                    <TableCell>{`${row.ream_count} `}</TableCell>
                                                    <TableCell>{row.status}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                )}

                                <Box display="flex" justifyContent="flex-end" sx={{ mt: 2 }}>
                                    <Pagination
                                        count={pageCount}
                                        page={currentPage}
                                        onChange={(event, value) => setCurrentPage(value)}

                                    />
                                </Box>
                            </TableContainer>
                        </CustomTableContainer>
                    </ResponsiveBox>

                </>
            )}


            {newJob && (



                <>
                    <Header title={t('prod_menu.reampunching')} subtitle="" callback={callback} />
                    <Dialog
                        open={open}
                        onClose={closepopup}
                        fullWidth
                        maxWidth="xs"

                    >
                        <DialogContent sx={{ backgroundColor: theme.palette.background.default }}>
                            <QualityCheckRejectProcee rejectReelType={'REAM'} rejectReason={rejectReason} setRejectReason={setRejectReason} selectedReason={selectedReason} setSelectedReason={setSelectedReason} rejectProductType={rejectProductType} setRejectProductType={setRejectProductType} rejectStatus={rejectStatus} setRejectStatus={setRejectStatus} rejectReasonID={rejectReasonID} setRejectReasonID={setRejectReasonID} rejectRemarks={rejectRemarks} setRejectRemarks={setRejectRemarks} enableReject={enableReject} setEnableReject={setEnableReject} />
                        </DialogContent>
                        <DialogActions sx={{ backgroundColor: theme.palette.background.default }}>
                            <Button onClick={closepopup} variant="contained">
                                Update
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Divider />


                    <Grid container display="flex-start" padding={0.5}>
                        {viewPalletList && (
                            <>
                                <Grid item md={0} ml="1px" mr="1px">
                                    <Tooltip title="Back to Line item wise achieved reel ">
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <IconButton onClick={() => handleSubMenuButtonClick('Line Item Wise Achieved Reels')}  >
                                                <ArrowBackIcon style={{ fontSize: "18px", color: selectedButton === 'Line Item Wise Achieved Reels' ? "yellow" : "#009688" }} />
                                                <Typography variant="h6" sx={{ marginLeft: "5px" }}>Line Item Wise Achieved Reels</Typography>
                                            </IconButton>
                                            {/* <span style={{ fontSize: 12 }}>Edit</span> */}
                                        </div>
                                    </Tooltip>
                                </Grid>
                                <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
                                <Grid item md={0} ml="1px" mr="1px">
                                    <Tooltip title="View available pallet list for production">
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <IconButton onClick={() => handleSubMenuButtonClick('View Reel List')} >
                                                <CheckCircleOutlinedIcon style={{ fontSize: "18px", color: selectedButton === 'View Reel List' ? "yellow" : "#009688" }} />
                                                <Typography variant="h6" sx={{ marginLeft: "5px" }}>Pallet List</Typography>
                                            </IconButton>
                                        </div>
                                    </Tooltip>
                                </Grid>
                                <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
                            </>
                        )}


                        {viewReamProcess && (
                            <>
                                {jobID === 0 && (
                                    <>
                                        <Grid item md={0} ml="1px" mr="1px">
                                            <Tooltip title="Back to View Pallet list">
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                    <IconButton onClick={() => handleSubMenuButtonClick('View Reel List')} >
                                                        <ArrowBackIcon style={{ fontSize: "18px", color: selectedButton === 'View Reel List' ? "yellow" : "#009688" }} />
                                                        <Typography variant="h6" sx={{ marginLeft: "5px" }}>Pallet List</Typography>
                                                    </IconButton>
                                                </div>
                                            </Tooltip>
                                        </Grid>
                                        <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
                                        <Grid item md={0} ml="1px" mr="1px">
                                            <Tooltip title="Convert pallets to reams process">
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                    <IconButton onClick={() => handleSubMenuButtonClick('View Sheeter Process')} >
                                                        <ArticleIcon style={{ fontSize: "18px", color: selectedButton === 'View Sheeter Process' ? "yellow" : "#009688" }} />
                                                        <Typography variant="h6" sx={{ marginLeft: "5px" }}>Sheeter Process</Typography>
                                                    </IconButton>
                                                </div>
                                            </Tooltip>
                                        </Grid>
                                        <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />

                                    </>
                                )}
                                {jobID > 0 && (
                                    <>

                                        <Grid item md={0} ml="1px" mr="1px">
                                            <Tooltip title="Back to Summary list">
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                    <IconButton onClick={() => handleSubMenuButtonClick('View Summary')} >
                                                        <ArrowBackIcon style={{ fontSize: "18px", color: selectedButton === 'View Summary' ? "yellow" : "#009688" }} />
                                                        <Typography variant="h6" sx={{ marginLeft: "5px" }}>Summary</Typography>
                                                    </IconButton>
                                                </div>
                                            </Tooltip>
                                        </Grid>
                                        <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />


                                        <Grid item md={0} ml="1px" mr="1px">
                                            <Tooltip title="Convert pallets to reams process">
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                    <IconButton onClick={() => handleSubMenuButtonClick('View Sheeter Process')} >
                                                        <ArticleIcon style={{ fontSize: "18px", color: selectedButton === 'View Sheeter Process' ? "yellow" : "#009688" }} />
                                                        <Typography variant="h6" sx={{ marginLeft: "5px" }}>Ream Punching Process</Typography>
                                                    </IconButton>
                                                </div>
                                            </Tooltip>
                                        </Grid>
                                        <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
                                    </>
                                )}
                            </>
                        )}
                    </Grid>

                    {viewLineItemList === false && (
                        <Divider />
                    )}


                    {/* Message box detail */}
                    <CallAlertBar parentRollMsgOpen={sheeterMsgOpen} setParentRollMsgOpen={setSheeterMsgOpen} parentRollSeverityvalue={sheeterSeverityvalue}
                        setParentRollSeverityvalue={setSheeterSeverityvalue} parentRollAlertTitleValue={sheeterAlertTitleValue}
                        setParentRollAlertTitleValue={setSheeterAlertTitleValue} parentRollMessageValue={sheeterMessageValue} setParentRollMessageValue={setSheeterMessageValue} />


                    <Box
                        sx={{
                            // backgroundColor: colors.primary[700],
                            padding: "10px",
                            borderRadius: "10px",
                            marginTop: "10px",
                            maxHeight: {
                                xs: '72vh', // Extra small devices (phones)
                                sm: '72vh', // Small devices (tablets)
                                md: '74vh', // Medium devices (small laptops)
                                lg: '76vh', // Large devices (desktops)
                                xl: '82vh', // Extra large devices (large desktops)
                            },
                            overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                            '&::-webkit-scrollbar': {
                                width: '8px',
                            },
                            '&::-webkit-scrollbar-track': {
                                background: colors.primary[400],
                                borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                background: colors.blueAccent[600],
                                borderRadius: '10px',
                                '&:hover': {
                                    background: colors.blueAccent[800],
                                },
                            },
                            '&::-webkit-scrollbar-corner': {
                                background: colors.primary[700],
                            }
                        }}>
                        <>


                            {(viewPalletList === false && viewReamProcess === false) && (
                                <>
                                    <Grid mt={1} item xs={12} sm={12} md={12} lg={12} xl={12}   >
                                        <Grid container padding="1px 0px 1px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                            {/* <Grid item xs={12} sm={12} md={1.6} lg={1} xl={1} display="flex-start" justifyContent="center">
                                                <Typography variant="h6"> {t('prod_paper_machine.filter_by')} </Typography>
                                            </Grid> */}

                                            {/* <Grid item xs={12} sm={11} md={3.8} lg={1.5} xl={1.25}>
                                                <FormControl fullWidth size="small">
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker
                                                            style={{ marginLeft: '10px' }}
                                                            id="FromDate"
                                                            value={dayjs(FromDate)}
                                                            onChange={(date) => handleDateChange2(date)}
                                                            slotProps={{ textField: { size: 'small', } }}
                                                            renderInput={(props) => <TextField {...props} />}
                                                            autoFocus
                                                            format="DD-MMM-YYYY" // Use the appropriate format string
                                                        />
                                                    </LocalizationProvider>
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={3.8} lg={1.5} xl={1.25}>
                                                <FormControl fullWidth size="small" >
                                                    <LocalizationProvider dateAdapter={AdapterDayjs} style={{ marginLeft: '10px' }}>
                                                        <DatePicker
                                                            id="ToDate"
                                                            value={dayjs(ToDate)}
                                                            format="DD-MMM-YYYY"
                                                            onChange={(date) => handleDateChange1(date)}
                                                            slotProps={{ textField: { size: 'small', } }}
                                                            renderInput={(props) => <TextField {...props} />}
                                                        />
                                                    </LocalizationProvider>
                                                </FormControl>
                                            </Grid> */}

                                            <Grid item xs={12} sm={12} md={1.6} lg={1} xl={1} display="flex-start" justifyContent="center">
                                                <Typography variant="h6">CO Number</Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={3.8} lg={1.8} xl={2}>
                                                <Autocomplete
                                                    fullWidth
                                                    value={filterIndentno}
                                                    onChange={handleIndentNoChange}
                                                    size="small"
                                                    style={{ fontSize: '12px' }}
                                                    options={indentNoList}
                                                    getOptionLabel={(option) => (option?.indent_no ? `${option.indent_no}` : '')} // Safely handle undefined
                                                    renderInput={(params) =>
                                                        <TextField required

                                                            {...params} variant="outlined" />}
                                                />
                                            </Grid>

                                        </Grid>
                                    </Grid>

                                    {viewLineItemList && (
                                        <>


                                            <Grid container padding="20px 0px 3px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                    {/* {loading && (
                        <Box sx={{ width: '100%', marginTop: '10px' }}>
                            <LinearProgress
                                variant="buffer"
                                sx={{
                                    '& .MuiLinearProgress-barColorPrimary': {
                                        backgroundColor: '#4CAF50', // Green color (you can replace this with your desired color)
                                    },
                                    '& .MuiLinearProgress-bar2Buffer': {
                                        backgroundColor: '#8BC34A', // Another shade of green for the buffer
                                    },
                                }}
                                value={progress}
                                valueBuffer={buffer}
                            />
                        </Box>
                    )} */}




                                                    <Divider />
                                                </Grid>
                                            </Grid>
                                        </>
                                    )}




                                    <Grid container spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>


                                            <CustomTableContainer colors={colors} >

                                                <TableContainer sx={{ position: 'relative' }}>
                                                    {loadingOrderItemDet ? (
                                                        <SkeletonTableLoader rows={5} columns={11} />
                                                    ) : (
                                                        <Table size="small">
                                                            <TableHead sx={{ height: 10 }}>
                                                                <TableRow>

                                                                    <TableCell sx={{ textAlign: "center", }}>CO DATE</TableCell>
                                                                    <TableCell sx={{ textAlign: "center", }}>CO NUMBER</TableCell>
                                                                    {/* <TableCell sx={{ textAlign: "center" }}>CUSTOMER NAME</TableCell>
                                                                <TableCell sx={{ textAlign: "center" }}>SUPPLIER NAME</TableCell> */}
                                                                    <TableCell sx={{ textAlign: "center" }}>QUALITY</TableCell>
                                                                    <TableCell sx={{ textAlign: "center" }}>GSM</TableCell>
                                                                    <TableCell sx={{ textAlign: "center" }}>WIDTH</TableCell>
                                                                    <TableCell sx={{ textAlign: "center" }}>LENGTH</TableCell>
                                                                    <TableCell sx={{ textAlign: "center" }}>PRODUCED PALLETS</TableCell>
                                                                    <TableCell sx={{ textAlign: "center" }}>ACH.QTY</TableCell>
                                                                    <TableCell sx={{ textAlign: "center" }}>PRODUCED QTY</TableCell>
                                                                    {/*<TableCell sx={{ textAlign: "center" }}>BALANCE QTY</TableCell>
                                                                <TableCell sx={{ textAlign: "center" }}>PRODUCED SHEETS</TableCell> */}
                                                                    <TableCell sx={{ textAlign: "center" }}>REAM WEIGHT</TableCell>
                                                                    <TableCell sx={{ textAlign: "center" }}>NO.OF.SHEETS IN REAM</TableCell>
                                                                    {/* <TableCell sx={{ textAlign: "center" }}>LINE NUMBER</TableCell> */}
                                                                    <TableCell>Action</TableCell>
                                                                    <TableCell>
                                                                        <IconButton onClick={handleOpen}>

                                                                            <Searchicon style={{ fontSize: "16px" }} />
                                                                        </IconButton>
                                                                        <Modal
                                                                            open={open}
                                                                            onClose={handleClose}
                                                                            aria-labelledby="modal-modal-title"
                                                                            aria-describedby="modal-modal-description"
                                                                        >
                                                                            <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: 4, minWidth: 300 }}>
                                                                                <TextField
                                                                                    label="CO NUMBER"
                                                                                    name="indent_no"
                                                                                    value={filters.indent_no}
                                                                                    onChange={handleFilterChange}
                                                                                    variant="outlined"
                                                                                    fullWidth
                                                                                    margin="normal"
                                                                                    size="small"
                                                                                />
                                                                                <TextField
                                                                                    label="QUALITY"
                                                                                    name="item_code"
                                                                                    value={filters.item_code}
                                                                                    onChange={handleFilterChange}
                                                                                    variant="outlined"
                                                                                    fullWidth
                                                                                    margin="normal"
                                                                                    size="small"
                                                                                />




                                                                                <Button variant="contained" style={{ marginTop: 10 }}>
                                                                                    {/* onClick={handleClose}  */}
                                                                                    Apply Filter
                                                                                </Button>
                                                                            </Box>
                                                                        </Modal>
                                                                    </TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {filteredData.map((row) => (
                                                                    <>
                                                                        <React.Fragment key={row.indent_no}>
                                                                            <TableRow key={row.id}>
                                                                                <TableCell sx={{ textAlign: "center" }}>{row.indent_date}</TableCell>
                                                                                <TableCell sx={{ textAlign: "left", fontWeight: "bold" }}>
                                                                                    <span
                                                                                        style={{ color: '#039be5', textDecoration: 'underline', cursor: 'pointer' }}
                                                                                        onClick={() => handleCallEdit(row)}
                                                                                    >
                                                                                        {row.indent_no}
                                                                                    </span>
                                                                                </TableCell>
                                                                                {/* <TableCell sx={{ textAlign: "left" }}>{row.customer_name}</TableCell>
                                                                    <TableCell sx={{ textAlign: "left" }}>{row.supplier_name}</TableCell> */}
                                                                                <TableCell sx={{ textAlign: "left" }}>{row.item_code}</TableCell>
                                                                                <TableCell sx={{ textAlign: "center" }}>{row.gsm}</TableCell>
                                                                                <TableCell sx={{ textAlign: "right" }}>{row.d_width}</TableCell>
                                                                                <TableCell sx={{ textAlign: "right" }}>{row.d_length}</TableCell>
                                                                                <TableCell sx={{ textAlign: "right" }}>{row.reel_count}</TableCell>
                                                                                <TableCell sx={{ textAlign: "right" }}>{row.total_qty}</TableCell>
                                                                                {/* 
                                                                    <TableCell sx={{ textAlign: "right" }}>{row.plannedqty}</TableCell>
                                                                    <TableCell sx={{ textAlign: "right" }}>{row.balanceqty}</TableCell>
                                                                    <TableCell sx={{ textAlign: "right" }}>{row.sheets_count}</TableCell> */}
                                                                                <TableCell sx={{ textAlign: "right" }}>{row.sheets_count}</TableCell>
                                                                                <TableCell sx={{ textAlign: "right" }}>{row.ream_weight}</TableCell>
                                                                                <TableCell sx={{ textAlign: "right" }}>{row.no_of_sheets}</TableCell>
                                                                                {/* <TableCell sx={{ textAlign: "center" }}>{row.line_no}</TableCell> */}
                                                                                <TableCell>
                                                                                    <Tooltip title="View child roll wise production">
                                                                                        <IconButton onClick={() => handleExpandRow(row)}>
                                                                                            {expandedRow === row.indent_no ? <ExpandLess style={{ color: 'teal', fontSize: "16px", fontWeight: "bold" }} /> : <ExpandMore style={{ color: 'teal', fontSize: "16px", fontWeight: "bold" }} />}
                                                                                        </IconButton>
                                                                                    </Tooltip>
                                                                                </TableCell>
                                                                            </TableRow>

                                                                            {/* Expanded Row */}
                                                                            {expandedRow === row.indent_no && (
                                                                                <TableRow>
                                                                                    <TableCell colSpan={8}>
                                                                                        <Collapse in={expandedRow === row.indent_no} timeout="auto" unmountOnExit>
                                                                                            <Box margin={1}>
                                                                                                {/* Expanded Data in Table Format */}
                                                                                                {expandedData[row.indent_no] ? (
                                                                                                    <Table size="small" aria-label="expanded-data">
                                                                                                        <TableHead>
                                                                                                            <TableRow>
                                                                                                                <TableCell></TableCell>
                                                                                                                <TableCell>PALLET CODE</TableCell>
                                                                                                                <TableCell sx={{ textAlign: "center", }}>SIZE</TableCell>
                                                                                                                <TableCell sx={{ textAlign: "center", }}>PALLET WEIGHT</TableCell>
                                                                                                                <TableCell sx={{ textAlign: "center", }}>NO OF SHEETS</TableCell>
                                                                                                                <TableCell sx={{ textAlign: "center", }}>CR NUMBER</TableCell>
                                                                                                                <TableCell sx={{ textAlign: "center", }}>PRODUCED SHEETS</TableCell>
                                                                                                                <TableCell sx={{ textAlign: "center", }}>PRODUCED WEIGHT</TableCell>
                                                                                                            </TableRow>
                                                                                                        </TableHead>
                                                                                                        <TableBody>
                                                                                                            {expandedData[row.indent_no].map((item, index) => (
                                                                                                                <TableRow key={index}>
                                                                                                                    <TableCell>{index + 1}</TableCell>
                                                                                                                    <TableCell>{item.pallet_code}</TableCell>
                                                                                                                    <TableCell sx={{ textAlign: "right" }}>{item.pallet_size}</TableCell>
                                                                                                                    <TableCell sx={{ textAlign: "right" }}>{item.pallet_weight}</TableCell>
                                                                                                                    <TableCell sx={{ textAlign: "right" }}>{item.no_of_sheets}</TableCell>
                                                                                                                    <TableCell sx={{ textAlign: "right" }}>{item.cr_number}</TableCell>
                                                                                                                    <TableCell sx={{ textAlign: "right" }}>{item.produced_sheets}</TableCell>
                                                                                                                    <TableCell sx={{ textAlign: "right" }}>{item.produced_weight}</TableCell>
                                                                                                                </TableRow>
                                                                                                            ))}
                                                                                                        </TableBody>
                                                                                                    </Table>
                                                                                                ) : (
                                                                                                    "Loading..."
                                                                                                )}
                                                                                            </Box>
                                                                                        </Collapse>
                                                                                    </TableCell>
                                                                                </TableRow>
                                                                            )}


                                                                        </React.Fragment>
                                                                    </>
                                                                ))}
                                                            </TableBody>
                                                        </Table>)}


                                                </TableContainer>
                                            </CustomTableContainer>

                                        </Grid>
                                    </Grid>
                                </>
                            )}

                            {/* view pallet list */}

                            {viewPalletList && (
                                <>
                                    <Grid container spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                        <Grid item xs={12} sm={12} md={12} lg={11} xl={11}>
                                            <CustomTableContainer colors={colors} >
                                                <TableContainer >
                                                    {/* <Table size="small">
                                                        <TableHead sx={{ height: 10 }}>
                                                            <TableRow>
                                                                <TableCell>
                                                                    <Checkbox size="small" sx={{
                                                                        '& .MuiSvgIcon-root': { fontSize: 20 }, // Adjust the size of the checkbox icon
                                                                        color: 'secondary' // Custom color
                                                                    }}
                                                                        indeterminate={selectedRows.length > 0 && selectedRows.length < filteredReelData.length}
                                                                        checked={selectedRows.length === filteredReelData.length}
                                                                        onChange={handleSelectAllClick}
                                                                    />
                                                                </TableCell>

                                                                <TableCell sx={{ textAlign: "center" }}>PALLET CODE</TableCell>
                                                                <TableCell sx={{ textAlign: "center" }}>CR NUMBER</TableCell>
                                                                <TableCell sx={{ textAlign: "center" }}>QUALITY</TableCell>
                                                                <TableCell sx={{ textAlign: "center" }}>GSM</TableCell>
                                                                <TableCell sx={{ textAlign: "center" }}>PALLET SIZE</TableCell>
                                                                <TableCell sx={{ textAlign: "center" }}>PALLET WEIGHT</TableCell>

                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {filteredReelData.map((row) => (
                                                                <TableRow key={row.id_pallet} sx={{
                                                                    cursor: "pointer",
                                                                    opacity: 1
                                                                }}
                                                                    onClick={(event) => handleRowClick(event, row.id_pallet, row.status)}>

                                                                    <TableCell>
                                                                        <Checkbox
                                                                            size="small"
                                                                            sx={{
                                                                                '& .MuiSvgIcon-root': { fontSize: 20 }, // Adjust the size of the checkbox icon
                                                                                color: 'secondary' // Custom color
                                                                            }}
                                                                            checked={isSelected(row.id_pallet)}
                                                                            disabled={row.status === 'converted'}
                                                                            onChange={(event) => handleRowCheckboxClick(event, row.id_pallet)}
                                                                        />
                                                                    </TableCell>
                                                                    <TableCell sx={{ textAlign: "left" }}>{row.pallet_code}</TableCell>
                                                                    <TableCell sx={{ textAlign: "left", }}>{row.cr_number}</TableCell>
                                                                    <TableCell sx={{ textAlign: "left", }}>{row.item_code}</TableCell>
                                                                    <TableCell sx={{ textAlign: "right" }}>{row.gsm}</TableCell>
                                                                    <TableCell sx={{ textAlign: "center", }}>{row.pallet_size}</TableCell>
                                                                    <TableCell sx={{ textAlign: "right" }}>{row.pallet_weight}</TableCell>
                                                                    <TableCell sx={{ textAlign: 'center' }}>
                                                                        <Tooltip title="Child-Reel to Ream Conversion Status">
                                                                            <Box
                                                                                component="span"
                                                                                sx={{
                                                                                    display: 'inline-block',
                                                                                    px: 2,
                                                                                    py: 0.4,
                                                                                    borderRadius: '16px',
                                                                                    bgcolor:
                                                                                        row.status?.toLowerCase() === 'converted'
                                                                                            ? '#00838f' // gray for converted
                                                                                            : row.status?.toLowerCase() === 'approved'
                                                                                                ? '#388e3c' // green for approved
                                                                                                : row.status?.toLowerCase() === 'wip'
                                                                                                    ? '#0288d1' // blue for work-in-progress
                                                                                                    : '#f57c00', // orange for any other / unknown
                                                                                    color: 'white',
                                                                                    fontWeight: 500,
                                                                                    fontSize: '0.8rem',
                                                                                    textTransform: 'capitalize',
                                                                                    textAlign: 'center',
                                                                                    fontFamily: 'Roboto, sans-serif',
                                                                                    boxShadow: '0 2px 4px rgba(0,0,0,0.15)',
                                                                                }}
                                                                            >
                                                                                {row.status}
                                                                            </Box>
                                                                        </Tooltip>
                                                                    </TableCell>


                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table> */}

                                                    <Table size="small">
                                                        <TableHead sx={{ height: 10 }}>
                                                            <TableRow>
                                                                <TableCell>
                                                                    <Checkbox
                                                                        size="small"
                                                                        sx={{
                                                                            '& .MuiSvgIcon-root': { fontSize: 22 },
                                                                            color: 'secondary',
                                                                        }}
                                                                        indeterminate={someSelected}
                                                                        checked={allSelected}
                                                                        onChange={handleSelectAllClick}
                                                                    />
                                                                </TableCell>
                                                                <TableCell sx={{ textAlign: "center" }}>PALLET CODE</TableCell>
                                                                <TableCell sx={{ textAlign: "center" }}>CR NUMBER</TableCell>
                                                                <TableCell sx={{ textAlign: "center" }}>QUALITY</TableCell>
                                                                <TableCell sx={{ textAlign: "center" }}>GSM</TableCell>
                                                                <TableCell sx={{ textAlign: "center" }}>PALLET SIZE</TableCell>
                                                                <TableCell sx={{ textAlign: "center" }}>PALLET WEIGHT</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {filteredReelData.map((row) => (
                                                                <TableRow
                                                                    key={row.id_pallet}
                                                                    sx={{
                                                                        cursor: "pointer",
                                                                        opacity: 1
                                                                    }}
                                                                    onClick={(event) => handleRowClick(event, row.id_pallet, row.status)}
                                                                >
                                                                    <TableCell>
                                                                        <Checkbox
                                                                            size="small"
                                                                            sx={{
                                                                                '& .MuiSvgIcon-root': { fontSize: 22 },
                                                                                color: 'secondary'
                                                                            }}
                                                                            checked={isSelected(row.id_pallet)}
                                                                            disabled={row.status === 'converted'}
                                                                            onChange={(event) => handleRowCheckboxClick(event, row.id_pallet)}
                                                                        />
                                                                    </TableCell>
                                                                    <TableCell sx={{ textAlign: "left" }}>{row.pallet_code}</TableCell>
                                                                    <TableCell sx={{ textAlign: "left" }}>{row.cr_number}</TableCell>
                                                                    <TableCell sx={{ textAlign: "left" }}>{row.item_code}</TableCell>
                                                                    <TableCell sx={{ textAlign: "right" }}>{row.gsm}</TableCell>
                                                                    <TableCell sx={{ textAlign: "center" }}>{row.pallet_size}</TableCell>
                                                                    <TableCell sx={{ textAlign: "right" }}>{row.pallet_weight}</TableCell>
                                                                    <TableCell sx={{ textAlign: 'center' }}>
                                                                        <Tooltip title="Child-Reel to Ream Conversion Status">
                                                                            <Box
                                                                                component="span"
                                                                                sx={{
                                                                                    display: 'inline-block',
                                                                                    px: 2,
                                                                                    py: 0.4,
                                                                                    borderRadius: '16px',
                                                                                    bgcolor:
                                                                                        row.status?.toLowerCase() === 'converted' ? '#00838f' :
                                                                                            row.status?.toLowerCase() === 'approved' ? '#388e3c' :
                                                                                                row.status?.toLowerCase() === 'wip' ? '#0288d1' :
                                                                                                    '#f57c00',
                                                                                    color: 'white',
                                                                                    fontWeight: 500,
                                                                                    fontSize: '0.8rem',
                                                                                    textTransform: 'capitalize',
                                                                                    textAlign: 'center',
                                                                                    fontFamily: 'Roboto, sans-serif',
                                                                                    boxShadow: '0 2px 4px rgba(0,0,0,0.15)',
                                                                                }}
                                                                            >
                                                                                {row.status}
                                                                            </Box>
                                                                        </Tooltip>
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </CustomTableContainer>
                                        </Grid>
                                    </Grid>

                                    <Grid container padding="10px 0px 10px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <Divider />
                                        </Grid>
                                    </Grid>

                                    {/* <Grid container padding="20px 0px 3px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <Box sx={{ display: "flex", justifyContent: "flex-end", marginRight: "10px" }}>
                                                <Button onClick={LoadSelectedLineItemList} variant="contained" color="secondary" size="small">Proceed</Button>
                                            </Box>
                                        </Grid>
                                    </Grid> */}

                                    {/* Button container */}
                                    <Box
                                        sx={{
                                            position: "fixed", // Keep the button fixed at the bottom
                                            bottom: 16, // Distance from the bottom of the viewport
                                            right: 25, // Distance from the right of the viewport
                                            zIndex: 1000, // Ensure it appears above other elements
                                        }}
                                    >




                                        <Button
                                            endIcon={
                                                <DoubleArrowRounded
                                                    className="arrow-icon"
                                                />
                                            }
                                            onClick={LoadSelectedLineItemList}
                                            sx={{
                                                textTransform: "none",
                                                borderRadius: 3,
                                                px: 2,
                                                py: 0.7,
                                                fontWeight: 600,
                                                fontSize: "0.8rem",
                                                letterSpacing: 0.3,
                                                transition: "all 0.3s ease",
                                                "&:hover": {
                                                    backgroundColor: (theme) => theme.palette.secondary.dark,
                                                    transform: "scale(1.03)",
                                                },
                                                "&:hover .arrow-icon": {
                                                    transform: "translateX(5px)",   // move the arrow slightly forward
                                                    transition: "transform 0.3s ease-in-out",
                                                },
                                            }}
                                            variant="contained"
                                            color="secondary"
                                            size="small"
                                            disabled={selectedRows.length === 0}
                                        >
                                            Proceed to Next
                                        </Button>
                                    </Box>

                                </>
                            )}


                            {jobID > 0 && (
                                <Grid container padding="1px 0px 10px 25px" sx={{ backgroundColor: colors.primary[400] }} spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                    <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                        <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                            JOB Number
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={11} md={3.8} lg={6} xl={6}>
                                        <TextField size="small" value={jobID} />
                                    </Grid>

                                </Grid>
                            )}

                            {viewReamProcess && (
                                <>





                                    <Grid container padding="0px 0px 10px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                        <Grid item xs={11} sm={6} md={11} lg={6} xl={6} display="flex-start" justifyContent="center" marginBottom="auto">

                                            <Box
                                                gridColumn="span 9"
                                                gridRow={"span 2"}
                                                alignItems="center"
                                                justifyContent="center"
                                                padding={0.5}
                                                sx={{
                                                    "& .MuiTable-root": {
                                                        border: "none",
                                                        size: "small",
                                                    },
                                                    "& .MuiTableCell-root": {
                                                        borderBottom: "none",
                                                        // fontWeight: "bold",
                                                        border: "1px solid ",
                                                        borderColor: `${colors.primary[100]} !important`,
                                                    },
                                                    "& .name-column--cell": {
                                                        color: colors.greenAccent[300],
                                                    },
                                                    "& .MuiTableHead-root": {
                                                        // backgroundColor: colors.blueAccent[700],
                                                        borderBottom: "none",

                                                    },
                                                    "& .MuiTableBody-root": {
                                                        overflowY: "auto",
                                                    },
                                                    "& .MuiCheckbox-root": {
                                                        color: `${colors.blueAccent[200]} !important`,
                                                        size: "small",
                                                    },
                                                    "& .MuiTableFooter-root": {
                                                        borderTop: "none",
                                                        backgroundColor: colors.blueAccent[700],
                                                        height: "10px",
                                                    },
                                                    "& .MuiButton-text": {
                                                        color: `${colors.grey[100]} !important`,
                                                    },

                                                }}>



                                            </Box>
                                        </Grid>


                                        {/* // enter ream punching details */}
                                        <Grid mt={0} item xs={12} sm={12} md={12} lg={12} xl={12}   >

                                            <Grid container padding="0px 0px 20px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                <Grid item xs={12} sm={12} md={9} lg={9} xl={9} display="flex-start" justifyContent="center">
                                                    <Box
                                                        sx={{
                                                            display: 'inline-flex',
                                                            borderBottom: '2px solid #ec407a'  // Underline color
                                                        }}
                                                    >

                                                        <Typography variant="h5" marginLeft="0px" padding="0px" marginTop={0} textAlign="left" >
                                                            Planning Details
                                                        </Typography>

                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={3} lg={3} xl={3} display="flex" marginRight="auto" justifyContent="center">
                                                    <Typography variant="h6" marginLeft="auto" marginRight="10px" >Total Sheets: {numberofSheets}</Typography>
                                                </Grid>
                                            </Grid>

                                            {/* <Divider sx={{ marginBottom: "20px" }} /> */}
                                            <Grid container padding="1px 0px 5px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                                                    <Typography variant="h6">{t('prod_sheet_convertion.shift_code')}</Typography>
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5}>
                                                    <Autocomplete
                                                        fullWidth
                                                        value={winderShiftCode}
                                                        onChange={handleWinderShiftChange}
                                                        size="small"
                                                        style={{ fontSize: '12px' }}
                                                        options={shiftCodes}
                                                        getOptionLabel={(option) => `${option.shiftcode}`}
                                                        renderInput={(params) =>
                                                            <TextField required
                                                                helperText={errorMessage}
                                                                error={errorMessage && errorMessage.length ? true : false}
                                                                {...params} variant="outlined" />}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={12} md={1} lg={1} xl={1} display="flex-start" justifyContent="center">
                                                    <Typography variant="h6" marginLeft={1}>{t('prod_sheet_convertion.shift_date_time')}</Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                                                    <FormControl fullWidth size="small">
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <Stack spacing={1} >
                                                                <DatePicker
                                                                    // label="Today Date"
                                                                    value={dayjs(shiftDate)}
                                                                    onChange={(date) => setShiftDate(date)}
                                                                    slotProps={{ textField: { size: 'small' } }}
                                                                    fullWidth
                                                                    format="DD-MMM-YYYY"

                                                                    renderInput={(props) => (
                                                                        <TextField
                                                                            helperText={shiftdate_errorMessage}
                                                                            error={shiftdate_errorMessage && shiftdate_errorMessage.length ? true : false}
                                                                            {...props} />
                                                                    )}

                                                                />
                                                            </Stack>
                                                        </LocalizationProvider>
                                                    </FormControl>
                                                </Grid>

                                                <Grid item xs={12} sm={12} md={1.8} lg={1.8} xl={1.8} display="flex-start" justifyContent="center">
                                                    <Typography variant="h6" marginLeft={1}>{t('prod_reams.Supervisor')}</Typography>
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                                                    <Autocomplete
                                                        fullWidth
                                                        value={selectedOperator}
                                                        onChange={handleOperatorChange}
                                                        size="small"
                                                        style={{ fontSize: '12px' }}
                                                        options={operator}
                                                        getOptionLabel={(option) => `${option.operator_code}`}
                                                        renderInput={(params) =>
                                                            <TextField required

                                                                {...params} variant="outlined" />}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">


                                            <Grid item xs={12} sm={12} md={1.55} lg={1.55} xl={1.55} display="flex-start" justifyContent="center">
                                                <Typography variant="h6" marginLeft={1}>{t('prod_reams.no_of_sheets')}</Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                                                <TextField
                                                    fullWidth
                                                    disabled={disableNumberofSheets}
                                                    size="small"
                                                    required
                                                    type='number'
                                                    value={sheeterNoOfSheets}
                                                    onChange={(e) => setSheeterNoOfSheets(e.target.value)}
                                                // onChange={CalculatePalletValue}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={1} lg={1} xl={1} display="flex-start" justifyContent="center">
                                                <Typography variant="h6" marginLeft={1}>{t('prod_reams.fno')}</Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={2} lg={2} xl={2} display="flex-start" justifyContent="center">
                                                <TextField
                                                    fullWidth
                                                    disabled={disableNumberofSheets}
                                                    size="small"
                                                    required
                                                    type='number'
                                                    value={fNo}
                                                    onChange={(e) => setFNo(e.target.value)}

                                                />
                                            </Grid>

                                            {/* <Grid item xs={12} sm={12} md={1.8} lg={1.8} xl={1.8} display="flex-start" justifyContent="center">
                                                <Typography variant="h6" marginLeft={1}>Actual Ream Production</Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={2} lg={2} xl={2} display="flex-start" justifyContent="center">
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    required
                                                    type='number'
                                                    value={actualReamProduction}
                                                    onChange={(e) => setActualReamProduction(e.target.value)}
                                                // onChange={CalculatePalletValue}
                                                />
                                            </Grid> */}

                                        </Grid>

                                        <Grid container padding="20px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <Divider />
                                            </Grid>
                                        </Grid>


                                        <Divider sx={{ marginTop: "0px" }} />
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}   >
                                            <Grid container >
                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={11} display="flex-start" >
                                                    <Box sx={{ padding: 3 }}>
                                                        <Typography sx={{
                                                            display: 'inline-flex',
                                                            borderBottom: '2px solid #ec407a'  // Underline color
                                                        }} variant="h5" gutterBottom mb={2}>
                                                            Child reel wise Produced Reams
                                                        </Typography>

                                                        {/* gowtham created ui */}
                                                        {/* {selectedUniqueReelList.map((reel) => {
                                                            // Find the existing sheetCount for the current reel
                                                            const existingSheetCount = sheetCounts.find(item => item.id_reel === reel.id_reel)?.sheetCount || "";

                                                            return (
                                                                <Grid
                                                                    key={reel.id_reel}
                                                                    container
                                                                    alignItems="center"
                                                                    spacing={2}
                                                                    sx={{ marginBottom: 2 }}
                                                                >
                                                                    <Grid item lg={4}>
                                                                        <Typography variant="body1" textAlign="left">
                                                                            Reel No: {reel.code}
                                                                        </Typography>
                                                                    </Grid>
                                                                    <Grid item lg={5.5}>
                                                                        <TextField
                                                                            size="small"
                                                                            label="No of Reams Produced"
                                                                            variant="outlined"
                                                                            fullWidth
                                                                            type="number"
                                                                            disabled={disableReelWiseSheetInput}
                                                                            value={existingSheetCount} // Set the value to the existing sheetCount
                                                                            onChange={(e) => {
                                                                                const value = e.target.value;
                                                                                // Prevent negative numbers
                                                                                if (value >= 0 || value === "") {
                                                                                    handleInputChange(reel.id_reel, value);
                                                                                }
                                                                            }}
                                                                            onKeyDown={(e) => {
                                                                                // Prevent typing negative symbol (-)
                                                                                if (e.key === "-" || e.key === "e") {
                                                                                    e.preventDefault();
                                                                                }
                                                                            }}
                                                                            onWheel={(e) => {
                                                                                // Prevent scrolling from affecting input value
                                                                                e.preventDefault();
                                                                            }}
                                                                        />
                                                                    </Grid>
                                                                </Grid>
                                                            );
                                                        })} */}

                                                        {/* //lakshmi lemit changes */}

                                                        <>
                                                            <CustomTableContainer colors={colors}>
                                                                <TableContainer>
                                                                    <Table size="small">
                                                                        <TableHead>
                                                                            <TableRow>
                                                                                <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>
                                                                                    Reel No
                                                                                </TableCell>
                                                                                <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>
                                                                                    No of Reams Produced
                                                                                </TableCell>
                                                                                <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>
                                                                                    Grade
                                                                                </TableCell>
                                                                                {/* <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>
            Production Qty
          </TableCell> */}
                                                                                <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>
                                                                                    Repulp Qty
                                                                                </TableCell>

                                                                                <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>
                                                                                    Remarks
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        </TableHead>

                                                                        <TableBody>
                                                                            {selectedUniqueReelList.map((reel) => {
                                                                                // Find the existing sheetCount for the current reel
                                                                                const existingSheetCount = sheetCounts.find(item => item.id_reel === reel.id_reel)?.sheetCount || "";
                                                                                const data = reamFormData.find(item => item.id_reel === reel.id_reel) || {};

                                                                                return (
                                                                                    <TableRow key={reel.id_reel}>
                                                                                        {/* Reel No */}
                                                                                        <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>{reel.code}</TableCell>

                                                                                        {/* No of Reams Produced */}
                                                                                        <TableCell align="right">
                                                                                            <TextField
                                                                                                size="small"
                                                                                                type="number"
                                                                                                variant="outlined"
                                                                                                fullWidth
                                                                                                disabled={disableReelWiseSheetInput}
                                                                                                value={existingSheetCount}
                                                                                                onChange={(e) => {
                                                                                                    const value = e.target.value;
                                                                                                    if (value >= 0 || value === "") {
                                                                                                        handleInputChange(reel.id_reel, value);
                                                                                                        updateReamField(reel.id_reel, "sheetCount", value);
                                                                                                    }
                                                                                                }}
                                                                                                onKeyDown={(e) => (e.key === "-" || e.key === "e") && e.preventDefault()}
                                                                                                onWheel={(e) => e.preventDefault()}
                                                                                                InputProps={{
                                                                                                    inputProps: { style: { textAlign: 'right' } }
                                                                                                }}
                                                                                                sx={{
                                                                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                                                                        border: 'none',
                                                                                                    },
                                                                                                    '& .MuiInputBase-input': {
                                                                                                        padding: '8px',
                                                                                                        textAlign: 'center',
                                                                                                    },
                                                                                                }}
                                                                                            />
                                                                                        </TableCell>

                                                                                        {/* Grade */}
                                                                                        <TableCell>
                                                                                            <Autocomplete
                                                                                                size="small"
                                                                                                options={["G1", "SL", "Repulp"]}
                                                                                                value={data.grade || ""}
                                                                                                onChange={(_, newVal) => updateReamField(reel.id_reel, "grade", newVal)}
                                                                                                renderInput={(params) => (
                                                                                                    <TextField
                                                                                                        {...params}
                                                                                                        fullWidth
                                                                                                        sx={{
                                                                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                                                                border: 'none',
                                                                                                            },
                                                                                                            '& .MuiInputBase-input': {
                                                                                                                padding: '8px',
                                                                                                            },
                                                                                                        }}


                                                                                                    />
                                                                                                )}

                                                                                            />
                                                                                        </TableCell>


                                                                                        {/* Repulp Qty */}
                                                                                        <TableCell align="right">
                                                                                            <TextField
                                                                                                size="small"
                                                                                                type="number"
                                                                                                fullWidth

                                                                                                value={data.repulp_qty}
                                                                                                onChange={e => {
                                                                                                    const val = e.target.value;
                                                                                                    if (val === "" || (!isNaN(val) && parseFloat(val) >= 0)) {
                                                                                                        updateReamField(reel.id_reel, "repulp_qty", val);
                                                                                                    }
                                                                                                }}
                                                                                                onKeyDown={e => {
                                                                                                    // prevent minus or "e"
                                                                                                    if (e.key === "-" || e.key === "e") {
                                                                                                        e.preventDefault();
                                                                                                    }
                                                                                                }}
                                                                                                onWheel={e => e.preventDefault()}
                                                                                                InputProps={{
                                                                                                    inputProps: { style: { textAlign: 'right', min: 0 } }
                                                                                                }}
                                                                                                sx={{
                                                                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                                                                        border: 'none',
                                                                                                    },
                                                                                                    '& .MuiInputBase-input': {
                                                                                                        padding: '8px',
                                                                                                        textAlign: 'center',
                                                                                                    },
                                                                                                }}
                                                                                            />

                                                                                        </TableCell>

                                                                                        {/* Remarks */}
                                                                                        <TableCell>
                                                                                            {/* <TextField
                                                                                                size="small"
                                                                                                fullWidth
                                                                                                value={data.remarks}
                                                                                                onChange={e => updateReamField(reel.id_reel, "winder_remarks", e.target.value)}
                                                                                                sx={{
                                                                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                                                                    },
                                                                                                    '& .MuiInputBase-input': {
                                                                                                        padding: '8px',
                                                                                                    },
                                                                                                }}
                                                                                            /> */}

                                                                                            <Box display="flex" alignItems="center">
                                                                                                <Autocomplete
                                                                                                    size="small"
                                                                                                    fullWidth
                                                                                                    loading={loadingRemarks}
                                                                                                    options={remarkOptions}   // full objects from API
                                                                                                    getOptionLabel={(option) => option?.description || ""}  // 👈 show only description
                                                                                                    // value={data.remarks || ""}  
                                                                                                    value={remarkOptions.find(opt => opt.description === data.winder_remarks) || null}
                                                                                                    onChange={(_, newVal) => updateReamField(reel.id_reel, "winder_remarks", newVal.description)}
                                                                                                    renderInput={(params) => (
                                                                                                        <TextField {...params} variant="outlined" />
                                                                                                    )}
                                                                                                />

                                                                                                <Tooltip title="Add New Remark">
                                                                                                    <IconButton
                                                                                                        onClick={handleOpenAddRemark}
                                                                                                        size="small"
                                                                                                        sx={{ ml: 1 }}
                                                                                                    >
                                                                                                        <AddCircleOutlineIcon color="secondary" />
                                                                                                    </IconButton>
                                                                                                </Tooltip>
                                                                                            </Box>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                );
                                                                            })}
                                                                        </TableBody>
                                                                    </Table>
                                                                </TableContainer>
                                                            </CustomTableContainer>


                                                            {/* 
                                                            <Box sx={{ mt: 2 }}>
                                                                <Typography variant="body1" fontWeight="bold">
                                                                    Total Reams Produced:{" "}
                                                                    {reamFormData.reduce((sum, r) => sum + (r.no_of_reams || 0), 0)}
                                                                </Typography>

                                                                <Typography variant="body1" fontWeight="bold">
                                                                    Total Production Qty:{" "}
                                                                    {reamFormData.reduce((sum, r) => sum + (r.produced_qty || 0), 0)}
                                                                </Typography>
                                                            </Box> */}
                                                        </>

                                                        {/* <Box sx={{ marginTop: 3 }}>
                                                            <Typography variant="h6">
                                                                Total Sheets Produced:
                                                                <Typography
                                                                    component="span"
                                                                    variant="h4"
                                                                    fontWeight="bold"
                                                                    sx={{ marginLeft: 1 }}
                                                                >

                                                                    {numberofSheets}
                                                                </Typography>
                                                            </Typography>

                                                        </Box> */}

                                                    </Box>
                                                </Grid>


                                            </Grid>
                                        </Grid>

                                        <Grid container padding="5px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <Divider />
                                            </Grid>
                                        </Grid>




                                        {sheeterNoOfSheets !== 0 && (


                                            <Grid container padding="10px 0px 5px 5px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">

                                                <Grid item xs={11} sm={11} md={10} lg={11.9} xl={11.9} display="flex-start" justifyContent="center">

                                                    <Grid container padding="0px 5px 5px 10px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">


                                                        <Grid item md={0} ml="5px" mr="5px">
                                                            <Tooltip title="Back to Line item wise achieved reams ">
                                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                                    <Typography variant="h6">{t('prod_reams.number_of_reams')}</Typography>
                                                                    <Typography variant="h4" fontWeight="bold">{numberofReams || 0}</Typography>
                                                                </div>
                                                            </Tooltip>
                                                        </Grid>
                                                        <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
                                                        <Grid item md={0} ml="5px" mr="5px">
                                                            <Tooltip title="View available ream list for production">
                                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                                    <Typography variant="h6">{t('prod_reams.l/r')}</Typography>
                                                                    <Typography variant="h4" fontWeight="bold">{lossReams || 0}</Typography>
                                                                </div>
                                                            </Tooltip>
                                                        </Grid>
                                                        <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
                                                        <Grid item md={0} ml="5px" mr="5px">
                                                            <Tooltip title="View available ream list for production">
                                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                                    <Typography variant="h6">{t('prod_reams.ream_weight')}</Typography>
                                                                    <Typography variant="h4" fontWeight="bold">{reamWeignt || 0} </Typography>
                                                                </div>
                                                            </Tooltip>
                                                        </Grid>
                                                        <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
                                                        <Grid item md={0} ml="5px" mr="5px">
                                                            <Tooltip title="View available ream list for production">
                                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                                    <Typography variant="h6"> L Ream Weight in Kgs</Typography>
                                                                    <Typography variant="h4" fontWeight="bold">{lReamWeignt || 0} </Typography>
                                                                </div>
                                                            </Tooltip>
                                                        </Grid>
                                                        <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />


                                                        {jobID === 0 && (
                                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                <Box sx={{ display: "flex", justifyContent: "flex-end", marginRight: "10px" }}>
                                                                    <Button variant="contained" onClick={() => createReams(0)} disabled={disableSaveBtn} color="secondary" size="small">Proceed</Button>



                                                                </Box>
                                                            </Grid>
                                                        )}

                                                        {jobID > 0 && (
                                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>


                                                                <Box sx={{ display: "flex", justifyContent: "flex-end", marginRight: "10px" }}>


                                                                    {hasPermission(userPermissions, "Ream Punching", "Update") && (
                                                                        <Button startIcon={<EditIcon />} sx={{ mr: '10px' }} variant="contained" onClick={() => createReams(1)} disabled={disableDeleteBtn} color="secondary" size="small">Update</Button>

                                                                    )}


                                                                    {hasPermission(userPermissions, "Ream Punching", "Delete") && (
                                                                        <Button variant="contained" onClick={DeleteReamProductionJobDetails} startIcon={<DeleteForeverOutlinedIcon />} disabled={disableDeleteBtn} sx={{ backgroundColor: '#e57373' }} size="small">Delete</Button>

                                                                    )}

                                                                </Box>
                                                            </Grid>
                                                        )}

                                                    </Grid>


                                                </Grid>

                                            </Grid>


                                        )}


                                    </Grid>
                                </>
                            )}

                            {viewReamQRCode && (
                                <>
                                    {/* <Box sx={{ backgroundColor: colors.primary[400], marginTop: "1px", border: "1px solid ", borderColor: colors.primary[300], borderRadius: "2px" }}> */}
                                    <Grid container padding="0px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                        <Grid mt={2} mb={0.5} item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                            <Typography variant="h5" fontWeight="bold" marginTop={0} textAlign="left">
                                                Ream List
                                            </Typography>
                                        </Grid>

                                    </Grid>

                                    {/* </Box> */}
                                    <Divider sx={{ marginTop: "10px" }} />

                                    <Grid container padding="1px 0px 10px 5px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                        <Grid item xs={11} sm={11} md={11} lg={5} xl={5} display="flex-start" justifyContent="center">


                                            <CustomTableContainer colors={colors} >
                                                <TableContainer >
                                                    <Table size="small">
                                                        <TableHead sx={{ height: 10 }}>
                                                            <TableRow>
                                                                <TableCell>
                                                                    <Checkbox size="small" sx={{

                                                                        color: 'secondary' // Custom color
                                                                    }}
                                                                        indeterminate={selectedReamRows.length > 0 && selectedReamRows.length < filteredReamData.length}
                                                                        checked={selectedReamRows.length === filteredReamData.length}
                                                                        onChange={handleSelectAllClickPallet}
                                                                    />
                                                                </TableCell>
                                                                <TableCell sx={{ textAlign: "center" }}>REAM CODE</TableCell>
                                                                <TableCell sx={{ textAlign: "center" }}>NUMBER OF SHEETS</TableCell>
                                                                <TableCell sx={{ textAlign: "center" }}>REAM WEIGHT</TableCell>
                                                                <TableCell sx={{ textAlign: "center" }}>STATUS</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {reamList.map((row) => {
                                                                const isChecked = isSelectedReam(row.ream_id);


                                                                return (
                                                                    <TableRow
                                                                        key={row.ream_id}
                                                                        hover
                                                                        sx={{
                                                                            cursor: "pointer",
                                                                            opacity: 1,
                                                                        }}
                                                                        onClick={() => {

                                                                            handleRowCheckboxClickPallet(null, row.ream_id);

                                                                        }}
                                                                    >
                                                                        <TableCell onClick={(e) => e.stopPropagation()}>
                                                                            <Checkbox
                                                                                size="small"
                                                                                sx={{ color: "secondary" }}
                                                                                checked={isChecked}

                                                                                onChange={(event) =>
                                                                                    handleRowCheckboxClickPallet(event, row.ream_id)
                                                                                }
                                                                            />
                                                                        </TableCell>

                                                                        <TableCell sx={{ textAlign: "left" }}>
                                                                            {row.ream_number}
                                                                        </TableCell>

                                                                        <TableCell sx={{ textAlign: "right" }}>
                                                                            {row.no_of_sheets}
                                                                        </TableCell>

                                                                        <TableCell sx={{ textAlign: "right" }}>
                                                                            {row.ream_weight}
                                                                        </TableCell>

                                                                        <TableCell sx={{ textAlign: "center" }}>
                                                                            <Chip
                                                                                label={row.ream_status}
                                                                                size="small"
                                                                                sx={{
                                                                                    color: "#fff",
                                                                                    textTransform: "capitalize",
                                                                                    background:
                                                                                        row.ream_status === "approved"
                                                                                            ? "linear-gradient(45deg, #388e3c, #2e7d32)"
                                                                                            : "linear-gradient(45deg, #00838f, #0097a7)",
                                                                                }}
                                                                            />
                                                                        </TableCell>
                                                                    </TableRow>
                                                                );
                                                            })}
                                                        </TableBody>


                                                        {/* <TableBody>
                                                            {reamList.map((row) => (
                                                                <TableRow key={row.ream_id}>
                                                                    <TableCell>
                                                                        <Checkbox
                                                                            size="small"
                                                                            sx={{
                                                                                
                                                                                color: 'secondary' // Custom color
                                                                            }}
                                                                            checked={isSelectedReam(row.ream_id)}
                                                                            // disabled={row.status === 'converted'}
                                                                            onChange={(event) => handleRowCheckboxClickPallet(event, row.ream_id)}
                                                                        />
                                                                    </TableCell>
                                                                    <TableCell sx={{ textAlign: "left" }}>{row.ream_number}</TableCell>
                                                                    <TableCell sx={{ textAlign: "right" }}>{row.no_of_sheets}</TableCell>
                                                                    <TableCell sx={{ textAlign: "right" }}>{row.ream_weight}</TableCell>
                                                                    <TableCell sx={{ textAlign: "center" }}>                                                                     



                                                                        <Chip
                                                                            label={row.ream_status}
                                                                            variant="filled"
                                                                            size="small"
                                                                            sx={{
                                                                                // fontWeight: "bold",
                                                                                textTransform: "capitalize",
                                                                                color: "#fff",
                                                                                background: row.ream_status === "approved"
                                                                                    ? "linear-gradient(45deg, #388e3c, #2e7d32)"
                                                                                    : "linear-gradient(45deg, #00838f, #0097a7)",
                                                                                boxShadow: "0 3px 5px rgba(0, 0, 0, 0.2)",
                                                                                transition: "transform 0.2s ease-in-out",
                                                                                // "&:hover": {
                                                                                //   transform: "scale(1.1)",
                                                                                //   boxShadow: "0 5px 8px rgba(0, 0, 0, 0.3)"
                                                                                // },
                                                                            }}
                                                                        />

                                                                    </TableCell>


                                                                </TableRow>
                                                            ))}
                                                        </TableBody> */}
                                                    </Table>
                                                </TableContainer>
                                            </CustomTableContainer>
                                        </Grid>
                                    </Grid>

                                    <Grid container padding="0px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                        <Box sx={{ top: 'auto', bottom: 0, backgroundColor: "transparent" }}>
                                            <Toolbar>
                                                {hasPermission(userPermissions, "Ream Punching", "View") && (
                                                    <Button type="submit" onClick={() => viewQRCode()} size="small" variant="contained" color="secondary" startIcon={<QrCode2RoundedIcon />} sx={{ textTransform: 'none' }}>{t('prod_sheet_convertion.btn_view_qr')}</Button>
                                                )}

                                                {hasPermission(userPermissions, "Ream Punching", "Print") && (
                                                    <Button type="submit" onClick={() => handleButtonClick('PrintQRAll')} size="small" variant="contained" color="secondary" startIcon={<QrCode2RoundedIcon />} sx={{ marginLeft: '10px', textTransform: 'none' }}>{t('prod_sheet_convertion.btn_print_qr')}</Button>
                                                )}

                                                {jobID > 0 && (
                                                    <>
                                                        {hasPermission(userPermissions, "Ream Punching", "Delete") && (
                                                            <Button type="submit" onClick={() => DeleteSelectedReamProductionJobDetails()} size="small" variant="contained" startIcon={<DeleteForeverOutlinedIcon />} sx={{ marginLeft: '10px', textTransform: 'none', backgroundColor: '#e57373' }}>Delete</Button>
                                                        )}
                                                    </>
                                                )}
                                            </Toolbar>
                                        </Box>
                                    </Grid>

                                    <Divider sx={{ marginTop: "10px" }} />

                                    <Grid container padding="0px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                        <Grid item mt={1} sm={11} md={11} lg={6} xl={4.5} >
                                            <div>
                                                {selectedReamDetails && selectedReamDetails.length > 0 && (

                                                    <LabelReamDetails qrCodeValue={''} ProductDetail={selectedReamDetails} company_id={localStorage.getItem('companyid')} />
                                                )}
                                            </div>
                                        </Grid>
                                    </Grid>
                                </>
                            )}

                            {viewReamProcess && (
                                <>

                                    <Grid container padding="20px 0px 10px 5px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>


                                            <Accordion   >
                                                {/*sx={{ backgroundColor: colors.primary[500] }} */}
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon sx={{ fontSize: "0.875rem" }} />}
                                                    sx={{
                                                        minHeight: "28px", // Smaller height for compactness
                                                        padding: "0 8px", // Reduced padding
                                                        // backgroundColor: colors.primary[400],
                                                        borderRadius: "2px",
                                                        "& .MuiAccordionSummary-content": {
                                                            margin: 0,
                                                            fontSize: "0.75rem", // Smaller font for a compact appearance
                                                            fontWeight: "bold",
                                                        },
                                                        "&.Mui-expanded": {
                                                            minHeight: "24px", // Keeps the header thin even when expanded
                                                        },
                                                    }}
                                                >
                                                    <Box display="flex" alignItems="center">
                                                        {/* Add the icon here */}
                                                        <InfoIcon sx={{ marginRight: '4px', fontSize: 16, color: colors.blueAccent[500] }} />
                                                        <Typography variant="subtitle2">View Customer Details</Typography>
                                                    </Box>


                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <Box
                                                        sx={{
                                                            // backgroundColor: colors.primary[700],
                                                            // padding: "10px",
                                                            borderRadius: "10px",
                                                            // marginTop: "10px",
                                                            maxHeight: {
                                                                xs: '72vh', // Extra small devices (phones)
                                                                sm: '72vh', // Small devices (tablets)
                                                                md: '74vh', // Medium devices (small laptops)
                                                                lg: '30vh', // Large devices (desktops)
                                                                xl: '30vh', // Extra large devices (large desktops)
                                                            },
                                                            overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                                                            '&::-webkit-scrollbar': {
                                                                width: '8px',
                                                            },
                                                            '&::-webkit-scrollbar-track': {
                                                                background: colors.primary[400],
                                                                borderRadius: '10px',
                                                            },
                                                            '&::-webkit-scrollbar-thumb': {
                                                                background: colors.blueAccent[600],
                                                                borderRadius: '10px',
                                                                '&:hover': {
                                                                    background: colors.blueAccent[800],
                                                                },
                                                            },
                                                            '&::-webkit-scrollbar-corner': {
                                                                background: colors.primary[700],
                                                            }
                                                        }}>
                                                        <>
                                                            <Box sx={{ padding: "5px", borderRadius: "1px" }}>
                                                                {/* backgroundColor: colors.primary[400], */}
                                                                <CustomTableContainer colors={colors} >
                                                                    <TableContainer >
                                                                        <Table size="small">
                                                                            <TableHead sx={{ height: 0 }}>
                                                                                <TableRow>

                                                                                    <TableCell sx={{ textAlign: "center" }}>CO DATE</TableCell>
                                                                                    <TableCell sx={{ textAlign: "center" }}>CO NUMBER</TableCell>
                                                                                    {/* <TableCell sx={{ textAlign: "center" }}>CUSTOMER NAME</TableCell>
                                                                                    <TableCell sx={{ textAlign: "center" }}>SUPPLIER NAME</TableCell> */}
                                                                                    <TableCell sx={{ textAlign: "center" }}>QUALITY</TableCell>
                                                                                    <TableCell sx={{ textAlign: "center" }}>GSM</TableCell>
                                                                                    <TableCell sx={{ textAlign: "center" }}>WIDTH</TableCell>
                                                                                    <TableCell sx={{ textAlign: "center" }}>LENGTH</TableCell>
                                                                                    <TableCell sx={{ textAlign: "center" }}>PRODUCED REAMS</TableCell>
                                                                                    <TableCell sx={{ textAlign: "center" }}>ACH.QTY</TableCell>

                                                                                    <TableCell sx={{ textAlign: "center" }}>REAM WEIGHT</TableCell>
                                                                                    <TableCell sx={{ textAlign: "center" }}>NO.OF.SHEETS IN REAM</TableCell>
                                                                                    <TableCell sx={{ textAlign: "center" }}>LINE NUMBER</TableCell>
                                                                                    <TableCell>
                                                                                        <IconButton >
                                                                                            {/* onClick={handleOpen} */}
                                                                                            <Searchicon style={{ fontSize: "16px" }} />
                                                                                        </IconButton>
                                                                                        <Modal
                                                                                            // open={open}
                                                                                            // onClose={handleClose}
                                                                                            aria-labelledby="modal-modal-title"
                                                                                            aria-describedby="modal-modal-description"
                                                                                        >
                                                                                            <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: 4, minWidth: 300 }}>
                                                                                                <TextField
                                                                                                    label="Parent Roll Number"
                                                                                                    name="name"
                                                                                                    // value={filters.pr_number}
                                                                                                    // onChange={handleFilterChange}
                                                                                                    variant="outlined"
                                                                                                    fullWidth
                                                                                                    margin="normal"
                                                                                                />
                                                                                                <TextField
                                                                                                    label="MA Number"
                                                                                                    name="companyName"
                                                                                                    // value={filters.release_no}
                                                                                                    // onChange={handleFilterChange}
                                                                                                    variant="outlined"
                                                                                                    fullWidth
                                                                                                    margin="normal"
                                                                                                />

                                                                                                <TextField
                                                                                                    label="Status"
                                                                                                    name="status"
                                                                                                    // value={filters.status}
                                                                                                    // onChange={handleFilterChange}
                                                                                                    variant="outlined"
                                                                                                    fullWidth
                                                                                                    margin="normal"
                                                                                                />


                                                                                                <Button variant="contained" style={{ marginTop: 10 }}>
                                                                                                    {/* onClick={handleClose}  */}
                                                                                                    Apply Filter
                                                                                                </Button>
                                                                                            </Box>
                                                                                        </Modal>
                                                                                    </TableCell>
                                                                                </TableRow>
                                                                            </TableHead>
                                                                            <TableBody>
                                                                                {selectedLineItemDetail.map((row) => (
                                                                                    <TableRow key={row.id}>

                                                                                        <TableCell sx={{ textAlign: "center" }}>{row.indent_date}</TableCell>
                                                                                        <TableCell sx={{ textAlign: "left", fontWeight: "bold" }}>
                                                                                            <span
                                                                                            // style={{ color: '#039be5', textDecoration: 'underline', cursor: 'pointer' }}
                                                                                            // onClick={() => handleCallEdit(row.indent_no, row.line_no)}
                                                                                            >
                                                                                                {row.indent_no}
                                                                                            </span>
                                                                                        </TableCell>
                                                                                        {/* <TableCell sx={{ textAlign: "left" }}>{row.customer_name}</TableCell>
                                                                                        <TableCell sx={{ textAlign: "left" }}>{row.supplier_name}</TableCell> */}
                                                                                        <TableCell sx={{ textAlign: "left" }}>{row.item_code}</TableCell>
                                                                                        <TableCell sx={{ textAlign: "center" }}>{row.gsm}</TableCell>
                                                                                        <TableCell sx={{ textAlign: "right" }}>{row.d_width}</TableCell>
                                                                                        <TableCell sx={{ textAlign: "right" }}>{row.d_length}</TableCell>
                                                                                        <TableCell sx={{ textAlign: "right" }}>{row.reel_count}</TableCell>
                                                                                        <TableCell sx={{ textAlign: "right" }}>{row.total_qty}</TableCell>

                                                                                        <TableCell sx={{ textAlign: "right" }}>{row.ream_weight}</TableCell>
                                                                                        <TableCell sx={{ textAlign: "right" }}>{row.no_of_sheets}</TableCell>
                                                                                        <TableCell sx={{ textAlign: "center" }}>{row.line_no}</TableCell>
                                                                                    </TableRow>
                                                                                ))}
                                                                            </TableBody>
                                                                        </Table>
                                                                    </TableContainer>
                                                                </CustomTableContainer>
                                                            </Box>
                                                        </>
                                                    </Box>
                                                </AccordionDetails>
                                            </Accordion>
                                        </Grid>
                                    </Grid>

                                    <Grid container padding="5px 0px 0px 5px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"  >
                                        <Grid item xs={11} sm={11} md={11} lg={12} xl={12} display="flex-start" justifyContent="center" marginBottom="auto">
                                            <Accordion   >
                                                {/*sx={{ backgroundColor: colors.primary[500] }} */}
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon sx={{ fontSize: "0.875rem" }} />}
                                                    sx={{
                                                        minHeight: "28px", // Smaller height for compactness
                                                        padding: "0 8px", // Reduced padding
                                                        // backgroundColor: colors.primary[400],
                                                        borderRadius: "2px",
                                                        "& .MuiAccordionSummary-content": {
                                                            margin: 0,
                                                            fontSize: "0.75rem", // Smaller font for a compact appearance
                                                            fontWeight: "bold",
                                                        },
                                                        "&.Mui-expanded": {
                                                            minHeight: "24px", // Keeps the header thin even when expanded
                                                        },
                                                    }}
                                                >
                                                    <Box display="flex" alignItems="center">
                                                        {/* Add the icon here */}
                                                        <InfoIcon sx={{ marginRight: '4px', fontSize: 16, color: colors.blueAccent[500] }} />
                                                        <Typography variant="subtitle2">View Selected Pallets</Typography>
                                                    </Box>


                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <Box
                                                        sx={{
                                                            // backgroundColor: colors.primary[700],
                                                            // padding: "10px",
                                                            borderRadius: "10px",
                                                            // marginTop: "10px",
                                                            maxHeight: {
                                                                xs: '72vh', // Extra small devices (phones)
                                                                sm: '72vh', // Small devices (tablets)
                                                                md: '74vh', // Medium devices (small laptops)
                                                                lg: '30vh', // Large devices (desktops)
                                                                xl: '30vh', // Extra large devices (large desktops)
                                                            },
                                                            overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                                                            '&::-webkit-scrollbar': {
                                                                width: '8px',
                                                            },
                                                            '&::-webkit-scrollbar-track': {
                                                                background: colors.primary[400],
                                                                borderRadius: '10px',
                                                            },
                                                            '&::-webkit-scrollbar-thumb': {
                                                                background: colors.blueAccent[600],
                                                                borderRadius: '10px',
                                                                '&:hover': {
                                                                    background: colors.blueAccent[800],
                                                                },
                                                            },
                                                            '&::-webkit-scrollbar-corner': {
                                                                background: colors.primary[700],
                                                            }
                                                        }}>
                                                        <>
                                                            <CustomTableContainer colors={colors} >
                                                                <TableContainer >
                                                                    <Table size="small">
                                                                        <TableHead sx={{ height: 10 }}>
                                                                            <TableRow>
                                                                                <TableCell sx={{ textAlign: "center" }}>PALLET NUMBER</TableCell>
                                                                                <TableCell sx={{ textAlign: "center" }}>QUALITY</TableCell>
                                                                                <TableCell sx={{ textAlign: "center" }}>GSM</TableCell>
                                                                                <TableCell sx={{ textAlign: "center" }}>SIZE</TableCell>
                                                                                <TableCell sx={{ textAlign: "center" }}>WEIGHT</TableCell>
                                                                                <TableCell sx={{ textAlign: "center" }}>NO OF SHEETS</TableCell>
                                                                                <TableCell sx={{ textAlign: "center" }}>STATUS</TableCell>
                                                                            </TableRow>
                                                                        </TableHead>
                                                                        <TableBody>
                                                                            {selectedReelList.map((row) => (
                                                                                <TableRow key={row.id_reel}>
                                                                                    <TableCell sx={{ textAlign: "left" }}>{row.pallet_code}</TableCell>
                                                                                    <TableCell sx={{ textAlign: "left" }}>{row.item_code}</TableCell>
                                                                                    <TableCell sx={{ textAlign: "center" }}>{row.gsm}</TableCell>
                                                                                    <TableCell sx={{ textAlign: "center" }}>{row.pallet_size}</TableCell>
                                                                                    <TableCell sx={{ textAlign: "right" }}>{row.pallet_weight}</TableCell>
                                                                                    <TableCell sx={{ textAlign: "right" }}>{row.number_of_sheets}</TableCell>
                                                                                    <TableCell sx={{ textAlign: "center" }}>{row.status}</TableCell>
                                                                                </TableRow>
                                                                            ))}
                                                                        </TableBody>
                                                                    </Table>
                                                                </TableContainer>
                                                            </CustomTableContainer>
                                                        </>
                                                    </Box>
                                                </AccordionDetails>
                                            </Accordion>
                                        </Grid>
                                    </Grid>
                                </>
                            )}
                        </>

                    </Box>

                    <Box
                        sx={{
                            // backgroundColor: colors.primary[700],
                            padding: "5px",
                            borderRadius: "10px",
                            maxHeight: {
                                xs: '72vh', // Extra small devices (phones)
                                sm: '72vh', // Small devices (tablets)
                                md: '74vh', // Medium devices (small laptops)
                                lg: '74vh', // Large devices (desktops)
                                xl: '82vh', // Extra large devices (large desktops)
                            },
                            overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                            '&::-webkit-scrollbar': {
                                width: '8px',
                            },
                            '&::-webkit-scrollbar-track': {
                                background: colors.primary[400],
                                borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                background: colors.blueAccent[600],
                                borderRadius: '10px',
                                '&:hover': {
                                    background: colors.blueAccent[800],
                                },
                            },
                            '&::-webkit-scrollbar-corner': {
                                background: colors.primary[700],
                            }
                        }}>

                        {viewReamLabeling && (
                            <div>

                                {showCard && (
                                    <Grid container padding="15px 0px 10px 10px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                        <Grid item xs={10.1} sm={10.6} md={11.9} lg={11.92} xl={11.95} display="flex-start" justifyContent="center">


                                            <Card sx={{ backgroundColor: colors.primary[500], borderRadius: "5px" }}>

                                                <CardContent>
                                                    <Box display="flex">
                                                        <Box>
                                                            <Typography sx={{ marginBottom: "5px" }}>Customer Details</Typography>
                                                        </Box>

                                                        <IconButton onClick={handleHide} sx={{ marginLeft: "auto" }} >
                                                            <CloseIcon style={{ color: "#ff5252", fontSize: "16px", fontWeight: "bold" }} />
                                                        </IconButton>

                                                    </Box>

                                                    <Box
                                                        gridColumn="span 9"
                                                        gridRow="span 2"
                                                        alignItems="center"
                                                        justifyContent="center"
                                                        // padding={1}
                                                        sx={{
                                                            "& .MuiTable-root": {
                                                                border: "none",
                                                                size: "small",
                                                            },
                                                            "& .MuiTableCell-root": {
                                                                borderBottom: "none",
                                                                border: "1px solid",
                                                                borderColor: `${colors.blueAccent[700]} !important`,
                                                                padding: "2px",  // Further reduced padding
                                                            },
                                                            "& .MuiTableHead-root": {
                                                                borderBottom: "none",
                                                            },
                                                            "& .MuiTableBody-root": {
                                                                overflowY: "auto",
                                                            },
                                                            "& .MuiCheckbox-root": {
                                                                color: `${colors.blueAccent[200]} !important`,
                                                                size: "small",
                                                            },
                                                            "& .MuiTableFooter-root": {
                                                                borderTop: "none",
                                                                backgroundColor: colors.blueAccent[700],
                                                                height: "10px",
                                                            },
                                                            "& .MuiButton-text": {
                                                                color: `${colors.grey[100]} !important`,
                                                            },
                                                        }}
                                                    >
                                                        <Table >
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Customer Name</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Supplier Name</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Indent Number</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Indent Date</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Line Number</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Master Reel</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Width</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Quality</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>GSM</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Diameter</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Inner Core</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Reel Length</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Reel Weight</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Number of Sheets</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Produced MO Number</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {childRollDetails?.map((row, index) => (
                                                                    <TableRow key={index}>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{row.customer_name || "N/A"}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{row.supplier_name || "N/A"}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{row.indent_no || "N/A"}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{formatDate(row.indent_date) || "N/A"}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{row.line_no || "N/A"}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{row.master_reel || "N/A"}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{row.d_width || "N/A"}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{row.quality || "N/A"}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{row.gsm || "N/A"}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{row.diameter || "N/A"}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{row.inner_core || "N/A"}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{row.reel_length || "N/A"}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{row.achieved_qty || "N/A"}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{row.no_of_sheets || "N/A"}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>{row.mo_number || "N/A"}</TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </Box>
                                                </CardContent>
                                            </Card>

                                        </Grid>
                                    </Grid>
                                )}
                            </div>
                        )}

                        {openAddRemark && (
                            <AddRemarks open={openAddRemark} onClose={handleCloseAddRemark} moduleName={"Ream Punching"} parentModuleName={"Production"} userPermissions={userPermissions} />
                        )}


                    </Box>
                </>

            )
            }



        </Box >
    )
}
export default ReamLabel;